window.questionsData = {
  "cografya": [
    {
      "id": "cografya_0",
      "text": "Türkiye ülkesinin başkenti neresidir?",
      "options": [
        "Pekin",
        "Tokyo",
        "Brasilia",
        "Ankara"
      ],
      "correct": 3
    },
    {
      "id": "cografya_1",
      "text": "Türkiye hangi kıtada yer almaktadır?",
      "options": [
        "Afrika",
        "Asya/Avrupa",
        "Kuzey Amerika",
        "Antarktika"
      ],
      "correct": 1
    },
    {
      "id": "cografya_2",
      "text": "Türkiye ülkesinin para birimi nedir?",
      "options": [
        "Türk Lirası",
        "Euro",
        "Euro",
        "Rupi"
      ],
      "correct": 0
    },
    {
      "id": "cografya_3",
      "text": "Almanya ülkesinin başkenti neresidir?",
      "options": [
        "Moskova",
        "Tokyo",
        "Roma",
        "Berlin"
      ],
      "correct": 3
    },
    {
      "id": "cografya_4",
      "text": "Almanya hangi kıtada yer almaktadır?",
      "options": [
        "Afrika",
        "Asya",
        "Avrupa",
        "Kuzey Amerika"
      ],
      "correct": 2
    },
    {
      "id": "cografya_5",
      "text": "Almanya ülkesinin para birimi nedir?",
      "options": [
        "Rupi",
        "Kanada Doları",
        "Avustralya Doları",
        "Euro"
      ],
      "correct": 3
    },
    {
      "id": "cografya_6",
      "text": "Fransa ülkesinin başkenti neresidir?",
      "options": [
        "Ottawa",
        "Kahire",
        "Paris",
        "Moskova"
      ],
      "correct": 2
    },
    {
      "id": "cografya_7",
      "text": "Fransa hangi kıtada yer almaktadır?",
      "options": [
        "Avrupa",
        "Okyanusya",
        "Antarktika",
        "Asya"
      ],
      "correct": 0
    },
    {
      "id": "cografya_8",
      "text": "Fransa ülkesinin para birimi nedir?",
      "options": [
        "Avustralya Doları",
        "Sterlin",
        "Kanada Doları",
        "Euro"
      ],
      "correct": 3
    },
    {
      "id": "cografya_9",
      "text": "Japonya ülkesinin başkenti neresidir?",
      "options": [
        "Pekin",
        "Madrid",
        "Brasilia",
        "Tokyo"
      ],
      "correct": 3
    },
    {
      "id": "cografya_10",
      "text": "Japonya hangi kıtada yer almaktadır?",
      "options": [
        "Asya",
        "Avrupa",
        "Afrika",
        "Kuzey Amerika"
      ],
      "correct": 0
    },
    {
      "id": "cografya_11",
      "text": "Japonya ülkesinin para birimi nedir?",
      "options": [
        "Euro",
        "Ruble",
        "Real",
        "Yen"
      ],
      "correct": 3
    },
    {
      "id": "cografya_12",
      "text": "Rusya ülkesinin başkenti neresidir?",
      "options": [
        "Kanberra",
        "Moskova",
        "Tokyo",
        "Kahire"
      ],
      "correct": 1
    },
    {
      "id": "cografya_13",
      "text": "Rusya hangi kıtada yer almaktadır?",
      "options": [
        "Güney Amerika",
        "Antarktika",
        "Asya/Avrupa",
        "Okyanusya"
      ],
      "correct": 2
    },
    {
      "id": "cografya_14",
      "text": "Rusya ülkesinin para birimi nedir?",
      "options": [
        "Mısır Lirası",
        "Ruble",
        "Yuan",
        "Euro"
      ],
      "correct": 1
    },
    {
      "id": "cografya_15",
      "text": "Mısır ülkesinin başkenti neresidir?",
      "options": [
        "Buenos Aires",
        "Kahire",
        "Yeni Delhi",
        "Tokyo"
      ],
      "correct": 1
    },
    {
      "id": "cografya_16",
      "text": "Mısır hangi kıtada yer almaktadır?",
      "options": [
        "Afrika",
        "Asya",
        "Kuzey Amerika",
        "Antarktika"
      ],
      "correct": 0
    },
    {
      "id": "cografya_17",
      "text": "Mısır ülkesinin para birimi nedir?",
      "options": [
        "Yen",
        "Mısır Lirası",
        "Yuan",
        "Kanada Doları"
      ],
      "correct": 1
    },
    {
      "id": "cografya_18",
      "text": "Brezilya ülkesinin başkenti neresidir?",
      "options": [
        "Londra",
        "Brasilia",
        "Pekin",
        "Berlin"
      ],
      "correct": 1
    },
    {
      "id": "cografya_19",
      "text": "Brezilya hangi kıtada yer almaktadır?",
      "options": [
        "Asya",
        "Güney Amerika",
        "Afrika",
        "Kuzey Amerika"
      ],
      "correct": 1
    },
    {
      "id": "cografya_20",
      "text": "Brezilya ülkesinin para birimi nedir?",
      "options": [
        "Ruble",
        "Real",
        "Euro",
        "Peso"
      ],
      "correct": 1
    },
    {
      "id": "cografya_21",
      "text": "Arjantin ülkesinin başkenti neresidir?",
      "options": [
        "Buenos Aires",
        "Berlin",
        "Madrid",
        "Moskova"
      ],
      "correct": 0
    },
    {
      "id": "cografya_22",
      "text": "Arjantin hangi kıtada yer almaktadır?",
      "options": [
        "Avrupa",
        "Güney Amerika",
        "Afrika",
        "Okyanusya"
      ],
      "correct": 1
    },
    {
      "id": "cografya_23",
      "text": "Arjantin ülkesinin para birimi nedir?",
      "options": [
        "Yen",
        "Sterlin",
        "Peso",
        "Yuan"
      ],
      "correct": 2
    },
    {
      "id": "cografya_24",
      "text": "Kanada ülkesinin başkenti neresidir?",
      "options": [
        "Berlin",
        "Ottawa",
        "Kahire",
        "Kanberra"
      ],
      "correct": 1
    },
    {
      "id": "cografya_25",
      "text": "Kanada hangi kıtada yer almaktadır?",
      "options": [
        "Kuzey Amerika",
        "Afrika",
        "Asya",
        "Güney Amerika"
      ],
      "correct": 0
    },
    {
      "id": "cografya_26",
      "text": "Kanada ülkesinin para birimi nedir?",
      "options": [
        "Kanada Doları",
        "Rupi",
        "Sterlin",
        "Peso"
      ],
      "correct": 0
    },
    {
      "id": "cografya_27",
      "text": "Çin ülkesinin başkenti neresidir?",
      "options": [
        "Buenos Aires",
        "Paris",
        "Pekin",
        "Kahire"
      ],
      "correct": 2
    },
    {
      "id": "cografya_28",
      "text": "Çin hangi kıtada yer almaktadır?",
      "options": [
        "Antarktika",
        "Kuzey Amerika",
        "Asya",
        "Güney Amerika"
      ],
      "correct": 2
    },
    {
      "id": "cografya_29",
      "text": "Çin ülkesinin para birimi nedir?",
      "options": [
        "Rupi",
        "Euro",
        "Yuan",
        "Kanada Doları"
      ],
      "correct": 2
    },
    {
      "id": "cografya_30",
      "text": "Hindistan ülkesinin başkenti neresidir?",
      "options": [
        "Brasilia",
        "Kanberra",
        "Berlin",
        "Yeni Delhi"
      ],
      "correct": 3
    },
    {
      "id": "cografya_31",
      "text": "Hindistan hangi kıtada yer almaktadır?",
      "options": [
        "Okyanusya",
        "Antarktika",
        "Güney Amerika",
        "Asya"
      ],
      "correct": 3
    },
    {
      "id": "cografya_32",
      "text": "Hindistan ülkesinin para birimi nedir?",
      "options": [
        "Yuan",
        "Euro",
        "Ruble",
        "Rupi"
      ],
      "correct": 3
    },
    {
      "id": "cografya_33",
      "text": "Avustralya ülkesinin başkenti neresidir?",
      "options": [
        "Kahire",
        "Kanberra",
        "Berlin",
        "Yeni Delhi"
      ],
      "correct": 1
    },
    {
      "id": "cografya_34",
      "text": "Avustralya hangi kıtada yer almaktadır?",
      "options": [
        "Kuzey Amerika",
        "Antarktika",
        "Güney Amerika",
        "Okyanusya"
      ],
      "correct": 3
    },
    {
      "id": "cografya_35",
      "text": "Avustralya ülkesinin para birimi nedir?",
      "options": [
        "Türk Lirası",
        "Avustralya Doları",
        "Yuan",
        "Euro"
      ],
      "correct": 1
    },
    {
      "id": "cografya_36",
      "text": "İtalya ülkesinin başkenti neresidir?",
      "options": [
        "Roma",
        "Paris",
        "Buenos Aires",
        "Madrid"
      ],
      "correct": 0
    },
    {
      "id": "cografya_37",
      "text": "İtalya hangi kıtada yer almaktadır?",
      "options": [
        "Afrika",
        "Avrupa",
        "Asya",
        "Güney Amerika"
      ],
      "correct": 1
    },
    {
      "id": "cografya_38",
      "text": "İtalya ülkesinin para birimi nedir?",
      "options": [
        "Euro",
        "Rupi",
        "Yuan",
        "Sterlin"
      ],
      "correct": 0
    },
    {
      "id": "cografya_39",
      "text": "İspanya ülkesinin başkenti neresidir?",
      "options": [
        "Tokyo",
        "Ottawa",
        "Madrid",
        "Yeni Delhi"
      ],
      "correct": 2
    },
    {
      "id": "cografya_40",
      "text": "İspanya hangi kıtada yer almaktadır?",
      "options": [
        "Avrupa",
        "Asya",
        "Afrika",
        "Okyanusya"
      ],
      "correct": 0
    },
    {
      "id": "cografya_41",
      "text": "İspanya ülkesinin para birimi nedir?",
      "options": [
        "Yen",
        "Euro",
        "Mısır Lirası",
        "Ruble"
      ],
      "correct": 1
    },
    {
      "id": "cografya_42",
      "text": "İngiltere ülkesinin başkenti neresidir?",
      "options": [
        "Ankara",
        "Londra",
        "Pekin",
        "Paris"
      ],
      "correct": 1
    },
    {
      "id": "cografya_43",
      "text": "İngiltere hangi kıtada yer almaktadır?",
      "options": [
        "Okyanusya",
        "Asya",
        "Avrupa",
        "Afrika"
      ],
      "correct": 2
    },
    {
      "id": "cografya_44",
      "text": "İngiltere ülkesinin para birimi nedir?",
      "options": [
        "Yuan",
        "Türk Lirası",
        "Sterlin",
        "Euro"
      ],
      "correct": 2
    },
    {
      "id": "cografya_45",
      "text": "Dünyanın en büyük okyanusu hangisidir?",
      "options": [
        "Hint Okyanusu",
        "Atlas Okyanusu",
        "Kuzey Buz Denizi",
        "Büyük Okyanus (Pasifik)"
      ],
      "correct": 3
    },
    {
      "id": "cografya_46",
      "text": "Dünyanın en uzun nehri hangisidir?",
      "options": [
        "Amazon Nehri",
        "Yangtze Nehri",
        "Mississippi Nehri",
        "Nil Nehri"
      ],
      "correct": 3
    },
    {
      "id": "cografya_47",
      "text": "Dünyanın en büyük çölü hangisidir?",
      "options": [
        "Büyük Sahra",
        "Gobi",
        "Atacama",
        "Kalahari"
      ],
      "correct": 0
    }
  ],
  "tarih": [
    {
      "id": "tarih_0",
      "text": "İstanbul'un Fethi hangi yılda gerçekleşmiştir?",
      "options": [
        "1453",
        "1922",
        "1492",
        "1923"
      ],
      "correct": 0
    },
    {
      "id": "tarih_1",
      "text": "İstanbul'un Fethi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Bülent Ecevit",
        "Avrupa Devletleri",
        "Kanuni Sultan Süleyman",
        "Fatih Sultan Mehmet"
      ],
      "correct": 3
    },
    {
      "id": "tarih_2",
      "text": "Fransız İhtilali hangi yılda gerçekleşmiştir?",
      "options": [
        "375",
        "1789",
        "1923",
        "1914"
      ],
      "correct": 1
    },
    {
      "id": "tarih_3",
      "text": "Fransız İhtilali ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Fatih Sultan Mehmet",
        "Avrupa Devletleri",
        "Kristof Kolomb",
        "Fransız Halkı"
      ],
      "correct": 3
    },
    {
      "id": "tarih_4",
      "text": "Cumhuriyetin İlanı hangi yılda gerçekleşmiştir?",
      "options": [
        "1492",
        "1939",
        "1453",
        "1923"
      ],
      "correct": 3
    },
    {
      "id": "tarih_5",
      "text": "Cumhuriyetin İlanı ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "İsmet İnönü",
        "Mustafa Kemal Atatürk",
        "Balamir",
        "Bülent Ecevit"
      ],
      "correct": 1
    },
    {
      "id": "tarih_6",
      "text": "Amerika'nın Keşfi hangi yılda gerçekleşmiştir?",
      "options": [
        "1789",
        "1492",
        "1215",
        "1914"
      ],
      "correct": 1
    },
    {
      "id": "tarih_7",
      "text": "Amerika'nın Keşfi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Avrupa Devletleri",
        "Kristof Kolomb",
        "Avrupa Devletleri",
        "Balamir"
      ],
      "correct": 1
    },
    {
      "id": "tarih_8",
      "text": "I. Dünya Savaşı'nın Başlaması hangi yılda gerçekleşmiştir?",
      "options": [
        "1923",
        "1974",
        "1215",
        "1914"
      ],
      "correct": 3
    },
    {
      "id": "tarih_9",
      "text": "I. Dünya Savaşı'nın Başlaması ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Avrupa Devletleri",
        "Fatih Sultan Mehmet",
        "Yurtsuz John",
        "Alparslan"
      ],
      "correct": 0
    },
    {
      "id": "tarih_10",
      "text": "II. Dünya Savaşı'nın Başlaması hangi yılda gerçekleşmiştir?",
      "options": [
        "1923",
        "1939",
        "1974",
        "1526"
      ],
      "correct": 1
    },
    {
      "id": "tarih_11",
      "text": "II. Dünya Savaşı'nın Başlaması ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "İsmet İnönü",
        "Mustafa Kemal Atatürk",
        "Fransa",
        "Avrupa Devletleri"
      ],
      "correct": 3
    },
    {
      "id": "tarih_12",
      "text": "Malazgirt Meydan Muharebesi hangi yılda gerçekleşmiştir?",
      "options": [
        "1071",
        "1914",
        "1526",
        "1453"
      ],
      "correct": 0
    },
    {
      "id": "tarih_13",
      "text": "Malazgirt Meydan Muharebesi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Alparslan",
        "Avrupa Devletleri",
        "Barbaros Hayreddin Paşa",
        "Yurtsuz John"
      ],
      "correct": 0
    },
    {
      "id": "tarih_14",
      "text": "Magna Carta'nın İmzalanması hangi yılda gerçekleşmiştir?",
      "options": [
        "1914",
        "1215",
        "1974",
        "1923"
      ],
      "correct": 1
    },
    {
      "id": "tarih_15",
      "text": "Magna Carta'nın İmzalanması ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Bülent Ecevit",
        "Avrupa Devletleri",
        "Yurtsuz John",
        "Fransız Halkı"
      ],
      "correct": 2
    },
    {
      "id": "tarih_16",
      "text": "Kavimler Göçü hangi yılda gerçekleşmiştir?",
      "options": [
        "1939",
        "1920",
        "1526",
        "375"
      ],
      "correct": 3
    },
    {
      "id": "tarih_17",
      "text": "Kavimler Göçü ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Balamir",
        "Alparslan",
        "Yurtsuz John",
        "Fransa"
      ],
      "correct": 0
    },
    {
      "id": "tarih_18",
      "text": "Fransız İhtilali hangi yılda gerçekleşmiştir?",
      "options": [
        "375",
        "1939",
        "1920",
        "1789"
      ],
      "correct": 3
    },
    {
      "id": "tarih_19",
      "text": "Fransız İhtilali ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Fatih Sultan Mehmet",
        "Bülent Ecevit",
        "Fransa",
        "Kristof Kolomb"
      ],
      "correct": 2
    },
    {
      "id": "tarih_20",
      "text": "TBMM'nin Açılışı hangi yılda gerçekleşmiştir?",
      "options": [
        "1922",
        "1526",
        "1920",
        "1923"
      ],
      "correct": 2
    },
    {
      "id": "tarih_21",
      "text": "TBMM'nin Açılışı ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Fransa",
        "Fransız Halkı",
        "Atatürk",
        "Avrupa Devletleri"
      ],
      "correct": 2
    },
    {
      "id": "tarih_22",
      "text": "Mudanya Mütarekesi hangi yılda gerçekleşmiştir?",
      "options": [
        "375",
        "1974",
        "1922",
        "1492"
      ],
      "correct": 2
    },
    {
      "id": "tarih_23",
      "text": "Mudanya Mütarekesi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "İsmet İnönü",
        "Yurtsuz John",
        "Atatürk",
        "Barbaros Hayreddin Paşa"
      ],
      "correct": 0
    },
    {
      "id": "tarih_24",
      "text": "Lozan Barış Antlaşması hangi yılda gerçekleşmiştir?",
      "options": [
        "1215",
        "1789",
        "1923",
        "1920"
      ],
      "correct": 2
    },
    {
      "id": "tarih_25",
      "text": "Lozan Barış Antlaşması ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Fransız Halkı",
        "Fatih Sultan Mehmet",
        "İsmet İnönü",
        "Fransa"
      ],
      "correct": 2
    },
    {
      "id": "tarih_26",
      "text": "Kıbrıs Barış Harekatı hangi yılda gerçekleşmiştir?",
      "options": [
        "1974",
        "1914",
        "1922",
        "1789"
      ],
      "correct": 0
    },
    {
      "id": "tarih_27",
      "text": "Kıbrıs Barış Harekatı ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Avrupa Devletleri",
        "Bülent Ecevit",
        "İsmet İnönü",
        "Fransa"
      ],
      "correct": 1
    },
    {
      "id": "tarih_28",
      "text": "Mohaç Meydan Muharebesi hangi yılda gerçekleşmiştir?",
      "options": [
        "1923",
        "1492",
        "1526",
        "1071"
      ],
      "correct": 2
    },
    {
      "id": "tarih_29",
      "text": "Mohaç Meydan Muharebesi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Kristof Kolomb",
        "Bülent Ecevit",
        "Avrupa Devletleri",
        "Kanuni Sultan Süleyman"
      ],
      "correct": 3
    },
    {
      "id": "tarih_30",
      "text": "Preveze Deniz Zaferi hangi yılda gerçekleşmiştir?",
      "options": [
        "1492",
        "1974",
        "1538",
        "1939"
      ],
      "correct": 2
    },
    {
      "id": "tarih_31",
      "text": "Preveze Deniz Zaferi ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Barbaros Hayreddin Paşa",
        "Kristof Kolomb",
        "Atatürk",
        "İsmet İnönü"
      ],
      "correct": 0
    },
    {
      "id": "tarih_32",
      "text": "Osmanlı Devleti'nin kurucusu kimdir?",
      "options": [
        "Fatih Sultan Mehmet",
        "Osman Gazi",
        "Ertuğrul Gazi",
        "Orhan Gazi"
      ],
      "correct": 1
    },
    {
      "id": "tarih_33",
      "text": "Türkiye Cumhuriyeti'nin ilk Cumhurbaşkanı kimdir?",
      "options": [
        "Mustafa Kemal Atatürk",
        "Adnan Menderes",
        "Celal Bayar",
        "İsmet İnönü"
      ],
      "correct": 0
    },
    {
      "id": "tarih_34",
      "text": "Hangi antlaşma ile I. Dünya Savaşı resmen sona ermiştir?",
      "options": [
        "Paris Antlaşması",
        "Versay Antlaşması",
        "Sevr Antlaşması",
        "Lozan Antlaşması"
      ],
      "correct": 1
    }
  ],
  "spor": [
    {
      "id": "spor_0",
      "text": "Futbol maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "13",
        "10",
        "12",
        "11"
      ],
      "correct": 3
    },
    {
      "id": "spor_1",
      "text": "Futbol sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "WADA",
        "FIFA",
        "UEFA",
        "IOC"
      ],
      "correct": 1
    },
    {
      "id": "spor_2",
      "text": "Basketbol maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "7",
        "4",
        "5",
        "6"
      ],
      "correct": 2
    },
    {
      "id": "spor_3",
      "text": "Basketbol sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "FIBA",
        "IOC",
        "WADA",
        "UEFA"
      ],
      "correct": 0
    },
    {
      "id": "spor_4",
      "text": "Voleybol maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "8",
        "5",
        "7",
        "6"
      ],
      "correct": 3
    },
    {
      "id": "spor_5",
      "text": "Voleybol sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "IOC",
        "WADA",
        "FIVB",
        "UEFA"
      ],
      "correct": 2
    },
    {
      "id": "spor_6",
      "text": "Hentbol maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "8",
        "7",
        "9",
        "6"
      ],
      "correct": 1
    },
    {
      "id": "spor_7",
      "text": "Hentbol sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "IHF",
        "UEFA",
        "WADA",
        "IOC"
      ],
      "correct": 0
    },
    {
      "id": "spor_8",
      "text": "Buz Hokeyi maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "5",
        "6",
        "7",
        "8"
      ],
      "correct": 1
    },
    {
      "id": "spor_9",
      "text": "Buz Hokeyi sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "IOC",
        "UEFA",
        "WADA",
        "IIHF"
      ],
      "correct": 3
    },
    {
      "id": "spor_10",
      "text": "Su Topu maçlarında bir takım sahada kaç oyuncu ile yer alır?",
      "options": [
        "9",
        "8",
        "7",
        "6"
      ],
      "correct": 2
    },
    {
      "id": "spor_11",
      "text": "Su Topu sporunun uluslararası en üst düzey yönetim organı hangisidir?",
      "options": [
        "IOC",
        "FINA",
        "WADA",
        "UEFA"
      ],
      "correct": 1
    },
    {
      "id": "spor_12",
      "text": "Türkiye Süper Ligi'nde en çok şampiyon olan takım hangisidir?",
      "options": [
        "Galatasaray",
        "Trabzonspor",
        "Fenerbahçe",
        "Beşiktaş"
      ],
      "correct": 0
    },
    {
      "id": "spor_13",
      "text": "Dünya Kupası'nı en çok kazanan ülke hangisidir?",
      "options": [
        "Arjantin",
        "Almanya",
        "İtalya",
        "Brezilya"
      ],
      "correct": 3
    },
    {
      "id": "spor_14",
      "text": "Olimpiyat halkalarında hangi renk bulunmaz?",
      "options": [
        "Mavi",
        "Siyah",
        "Kahverengi",
        "Sarı"
      ],
      "correct": 2
    },
    {
      "id": "spor_15",
      "text": "Boks maçlarının yapıldığı alana ne ad verilir?",
      "options": [
        "Ring",
        "Minder",
        "Pist",
        "Kort"
      ],
      "correct": 0
    },
    {
      "id": "spor_16",
      "text": "İlk modern olimpiyat oyunları hangi yıl düzenlenmiştir?",
      "options": [
        "1924",
        "1896",
        "1888",
        "1900"
      ],
      "correct": 1
    },
    {
      "id": "spor_17",
      "text": "Michael Jordan hangi sporda efsaneleşmiştir?",
      "options": [
        "Futbol",
        "Tenis",
        "Basketbol",
        "Golf"
      ],
      "correct": 2
    },
    {
      "id": "spor_18",
      "text": "Bir tenis maçında 'Deuce' ne anlama gelir?",
      "options": [
        "Çift Hata",
        "Maç Sayısı",
        "Servis Kırma",
        "40-40 Eşitlik"
      ],
      "correct": 3
    },
    {
      "id": "spor_19",
      "text": "Formula 1 yarışlarında en hızlı turu atan pilota ne verilir?",
      "options": [
        "Kupa",
        "Para Ödülü",
        "Pole Pozisyonu",
        "1 Ekstra Puan"
      ],
      "correct": 3
    },
    {
      "id": "spor_20",
      "text": "NBA'de logo üzerinde silüeti bulunan efsane oyuncu kimdir?",
      "options": [
        "Larry Bird",
        "Michael Jordan",
        "Jerry West",
        "Magic Johnson"
      ],
      "correct": 2
    },
    {
      "id": "spor_21",
      "text": "Spor Genel Kültür 0",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "spor_22",
      "text": "Spor Genel Kültür 1",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "spor_23",
      "text": "Spor Genel Kültür 2",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "spor_24",
      "text": "Spor Genel Kültür 3",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "spor_25",
      "text": "Spor Genel Kültür 4",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "spor_26",
      "text": "Spor Genel Kültür 5",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "spor_27",
      "text": "Spor Genel Kültür 6",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "spor_28",
      "text": "Spor Genel Kültür 7",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "spor_29",
      "text": "Spor Genel Kültür 8",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "spor_30",
      "text": "Spor Genel Kültür 9",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "spor_31",
      "text": "Spor Genel Kültür 10",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "spor_32",
      "text": "Spor Genel Kültür 11",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "spor_33",
      "text": "Spor Genel Kültür 12",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "spor_34",
      "text": "Spor Genel Kültür 13",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "spor_35",
      "text": "Spor Genel Kültür 14",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    }
  ],
  "fen_bilimleri": [
    {
      "id": "fen_bilimleri_0",
      "text": "Periyodik tabloda 'O' sembolü hangi elemente aittir?",
      "options": [
        "Azot",
        "Oksijen",
        "Fosfor",
        "Klor"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_1",
      "text": "Periyodik tabloda 'H' sembolü hangi elemente aittir?",
      "options": [
        "Fosfor",
        "Azot",
        "Klor",
        "Hidrojen"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_2",
      "text": "Periyodik tabloda 'C' sembolü hangi elemente aittir?",
      "options": [
        "Klor",
        "Fosfor",
        "Karbon",
        "Azot"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_3",
      "text": "Periyodik tabloda 'Au' sembolü hangi elemente aittir?",
      "options": [
        "Klor",
        "Altın",
        "Fosfor",
        "Azot"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_4",
      "text": "Periyodik tabloda 'Fe' sembolü hangi elemente aittir?",
      "options": [
        "Fosfor",
        "Klor",
        "Demir",
        "Azot"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_5",
      "text": "Periyodik tabloda 'Ag' sembolü hangi elemente aittir?",
      "options": [
        "Gümüş",
        "Azot",
        "Klor",
        "Fosfor"
      ],
      "correct": 0
    },
    {
      "id": "fen_bilimleri_6",
      "text": "Periyodik tabloda 'Cu' sembolü hangi elemente aittir?",
      "options": [
        "Fosfor",
        "Azot",
        "Bakır",
        "Klor"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_7",
      "text": "Periyodik tabloda 'Na' sembolü hangi elemente aittir?",
      "options": [
        "Klor",
        "Azot",
        "Fosfor",
        "Sodyum"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_8",
      "text": "Periyodik tabloda 'He' sembolü hangi elemente aittir?",
      "options": [
        "Fosfor",
        "Helyum",
        "Klor",
        "Azot"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_9",
      "text": "Periyodik tabloda 'Ca' sembolü hangi elemente aittir?",
      "options": [
        "Klor",
        "Fosfor",
        "Azot",
        "Kalsiyum"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_10",
      "text": "Güneş sistemindeki en büyük gezegen hangisidir?",
      "options": [
        "Dünya",
        "Jüpiter",
        "Mars",
        "Satürn"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_11",
      "text": "Işık hızı saniyede yaklaşık kaç kilometredir?",
      "options": [
        "30.000",
        "1.000.000",
        "300.000",
        "150.000"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_12",
      "text": "İnsan vücudundaki en büyük organ hangisidir?",
      "options": [
        "Akciğer",
        "Deri",
        "Karaciğer",
        "Kalp"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_13",
      "text": "Suyun kimyasal formülü nedir?",
      "options": [
        "CO2",
        "H2O",
        "NaCl",
        "O2"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_14",
      "text": "DNA'nın açılımı nedir?",
      "options": [
        "Dinamik Nükleer Asit",
        "Dioksit Nötral Asit",
        "Doğal Nükleik Asit",
        "Deoksiribo Nükleik Asit"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_15",
      "text": "Elektriği bulan bilim insanı kimdir?",
      "options": [
        "Thomas Edison",
        "Albert Einstein",
        "Benjamin Franklin",
        "Nikola Tesla"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_16",
      "text": "Dünyanın tek doğal uydusu hangisidir?",
      "options": [
        "Venüs",
        "Güneş",
        "Mars",
        "Ay"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_17",
      "text": "Kuvvetin birimi nedir?",
      "options": [
        "Newton",
        "Pascal",
        "Watt",
        "Joule"
      ],
      "correct": 0
    },
    {
      "id": "fen_bilimleri_18",
      "text": "Ses hangi ortamda en hızlı yayılır?",
      "options": [
        "Boşluk",
        "Gaz",
        "Sıvı",
        "Katı"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_19",
      "text": "Bilim 0",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_20",
      "text": "Bilim 1",
      "options": [
        "D",
        "A",
        "B",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_21",
      "text": "Bilim 2",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_22",
      "text": "Bilim 3",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_23",
      "text": "Bilim 4",
      "options": [
        "D",
        "A",
        "C",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_24",
      "text": "Bilim 5",
      "options": [
        "B",
        "A",
        "D",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "fen_bilimleri_25",
      "text": "Bilim 6",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "fen_bilimleri_26",
      "text": "Bilim 7",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "fen_bilimleri_27",
      "text": "Bilim 8",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "fen_bilimleri_28",
      "text": "Bilim 9",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    }
  ],
  "mitoloji_turk": [
    {
      "id": "mitoloji_turk_0",
      "text": "Türk mitolojisinde İyilik Tanrısı olarak bilinen figür kimdir/nedir?",
      "options": [
        "Börü",
        "Kayra Han",
        "Ülgen",
        "Gök Tengri"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_1",
      "text": "Türk mitolojisinde Kötülük Tanrısı olarak bilinen figür kimdir/nedir?",
      "options": [
        "Kayra Han",
        "Erlik",
        "Gök Tengri",
        "Börü"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_2",
      "text": "Türk mitolojisinde Bereket ve Doğum Tanrıçası olarak bilinen figür kimdir/nedir?",
      "options": [
        "Gök Tengri",
        "Kayra Han",
        "Börü",
        "Umay"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_3",
      "text": "Türk mitolojisinde Efsanevi Türk Hükümdarı olarak bilinen figür kimdir/nedir?",
      "options": [
        "Kayra Han",
        "Oğuz Kağan",
        "Börü",
        "Gök Tengri"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_4",
      "text": "Türk mitolojisinde Dişi Kurt olarak bilinen figür kimdir/nedir?",
      "options": [
        "Gök Tengri",
        "Börü",
        "Asena",
        "Kayra Han"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_5",
      "text": "Türk mitolojisinde Tek Gözlü Canavar olarak bilinen figür kimdir/nedir?",
      "options": [
        "Börü",
        "Kayra Han",
        "Gök Tengri",
        "Tepegöz"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_6",
      "text": "Türk mitolojisinde Kanatlı At olarak bilinen figür kimdir/nedir?",
      "options": [
        "Kayra Han",
        "Tulpar",
        "Gök Tengri",
        "Börü"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_7",
      "text": "Türk mitolojisinde Yağmur Yağdıran Taş olarak bilinen figür kimdir/nedir?",
      "options": [
        "Gök Tengri",
        "Börü",
        "Kayra Han",
        "Yada Taşı"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_8",
      "text": "Türk mitolojisinde Dünyanın Merkezindeki Ağaç olarak bilinen figür kimdir/nedir?",
      "options": [
        "Börü",
        "Kayra Han",
        "Hayat Ağacı",
        "Gök Tengri"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_9",
      "text": "Türk Mitolojisi Soru 0",
      "options": [
        "A",
        "B",
        "D",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_10",
      "text": "Türk Mitolojisi Soru 1",
      "options": [
        "A",
        "B",
        "D",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_11",
      "text": "Türk Mitolojisi Soru 2",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_12",
      "text": "Türk Mitolojisi Soru 3",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_13",
      "text": "Türk Mitolojisi Soru 4",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_14",
      "text": "Türk Mitolojisi Soru 5",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_15",
      "text": "Türk Mitolojisi Soru 6",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_16",
      "text": "Türk Mitolojisi Soru 7",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_17",
      "text": "Türk Mitolojisi Soru 8",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_18",
      "text": "Türk Mitolojisi Soru 9",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_19",
      "text": "Türk Mitolojisi Soru 10",
      "options": [
        "A",
        "D",
        "C",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_20",
      "text": "Türk Mitolojisi Soru 11",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_21",
      "text": "Türk Mitolojisi Soru 12",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_22",
      "text": "Türk Mitolojisi Soru 13",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_23",
      "text": "Türk Mitolojisi Soru 14",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_24",
      "text": "Türk Mitolojisi Soru 15",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_25",
      "text": "Türk Mitolojisi Soru 16",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_26",
      "text": "Türk Mitolojisi Soru 17",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_27",
      "text": "Türk Mitolojisi Soru 18",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_28",
      "text": "Türk Mitolojisi Soru 19",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_29",
      "text": "Türk Mitolojisi Soru 20",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_30",
      "text": "Türk Mitolojisi Soru 21",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_31",
      "text": "Türk Mitolojisi Soru 22",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_32",
      "text": "Türk Mitolojisi Soru 23",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_33",
      "text": "Türk Mitolojisi Soru 24",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_34",
      "text": "Türk Mitolojisi Soru 25",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_35",
      "text": "Türk Mitolojisi Soru 26",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_36",
      "text": "Türk Mitolojisi Soru 27",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_37",
      "text": "Türk Mitolojisi Soru 28",
      "options": [
        "A",
        "B",
        "D",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_38",
      "text": "Türk Mitolojisi Soru 29",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    }
  ],
  "mitoloji_yunan": [
    {
      "id": "mitoloji_yunan_0",
      "text": "Yunan mitolojisinde Tanrıların Kralı kimdir?",
      "options": [
        "Apollon",
        "Hephaistos",
        "Hermes",
        "Zeus"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_1",
      "text": "Yunan mitolojisinde Zeus'un sembolü nedir?",
      "options": [
        "Arp",
        "Çekiç",
        "Yay",
        "Şimşek"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_2",
      "text": "Yunan mitolojisinde Deniz Tanrısı kimdir?",
      "options": [
        "Poseidon",
        "Hermes",
        "Apollon",
        "Hephaistos"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_3",
      "text": "Yunan mitolojisinde Poseidon'un sembolü nedir?",
      "options": [
        "Üç Dişli Yaba",
        "Çekiç",
        "Arp",
        "Yay"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_4",
      "text": "Yunan mitolojisinde Yeraltı Tanrısı kimdir?",
      "options": [
        "Hephaistos",
        "Hermes",
        "Hades",
        "Apollon"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_5",
      "text": "Yunan mitolojisinde Hades'un sembolü nedir?",
      "options": [
        "Görünmezlik Miğferi",
        "Yay",
        "Çekiç",
        "Arp"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_6",
      "text": "Yunan mitolojisinde Savaş Tanrısı kimdir?",
      "options": [
        "Hermes",
        "Hephaistos",
        "Apollon",
        "Ares"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_7",
      "text": "Yunan mitolojisinde Ares'un sembolü nedir?",
      "options": [
        "Arp",
        "Yay",
        "Kılıç",
        "Çekiç"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_8",
      "text": "Yunan mitolojisinde Zeka ve Strateji Tanrıçası kimdir?",
      "options": [
        "Apollon",
        "Hermes",
        "Athena",
        "Hephaistos"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_9",
      "text": "Yunan mitolojisinde Athena'un sembolü nedir?",
      "options": [
        "Arp",
        "Çekiç",
        "Yay",
        "Baykuş"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_10",
      "text": "Yunan mitolojisinde Aşk ve Güzellik Tanrıçası kimdir?",
      "options": [
        "Hermes",
        "Hephaistos",
        "Aphrodite",
        "Apollon"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_11",
      "text": "Yunan mitolojisinde Aphrodite'un sembolü nedir?",
      "options": [
        "Gül",
        "Çekiç",
        "Arp",
        "Yay"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_12",
      "text": "Yunan Mitolojisi Soru 0",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_13",
      "text": "Yunan Mitolojisi Soru 1",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_yunan_14",
      "text": "Yunan Mitolojisi Soru 2",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_15",
      "text": "Yunan Mitolojisi Soru 3",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_16",
      "text": "Yunan Mitolojisi Soru 4",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_17",
      "text": "Yunan Mitolojisi Soru 5",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_18",
      "text": "Yunan Mitolojisi Soru 6",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_yunan_19",
      "text": "Yunan Mitolojisi Soru 7",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_20",
      "text": "Yunan Mitolojisi Soru 8",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_21",
      "text": "Yunan Mitolojisi Soru 9",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_22",
      "text": "Yunan Mitolojisi Soru 10",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_yunan_23",
      "text": "Yunan Mitolojisi Soru 11",
      "options": [
        "A",
        "B",
        "D",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_24",
      "text": "Yunan Mitolojisi Soru 12",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_yunan_25",
      "text": "Yunan Mitolojisi Soru 13",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_26",
      "text": "Yunan Mitolojisi Soru 14",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_27",
      "text": "Yunan Mitolojisi Soru 15",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_28",
      "text": "Yunan Mitolojisi Soru 16",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_yunan_29",
      "text": "Yunan Mitolojisi Soru 17",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_30",
      "text": "Yunan Mitolojisi Soru 18",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_31",
      "text": "Yunan Mitolojisi Soru 19",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_32",
      "text": "Yunan Mitolojisi Soru 20",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_33",
      "text": "Yunan Mitolojisi Soru 21",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_34",
      "text": "Yunan Mitolojisi Soru 22",
      "options": [
        "D",
        "B",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_yunan_35",
      "text": "Yunan Mitolojisi Soru 23",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_36",
      "text": "Yunan Mitolojisi Soru 24",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    }
  ],
  "mitoloji_misir": [
    {
      "id": "mitoloji_misir_0",
      "text": "Mısır mitolojisinde Güneş Tanrısı kimdir?",
      "options": [
        "Bastet",
        "Amun",
        "Ra",
        "Ptah"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_1",
      "text": "Mısır mitolojisinde Yeraltı ve Ölüm Tanrısı kimdir?",
      "options": [
        "Amun",
        "Osiris",
        "Ptah",
        "Bastet"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_2",
      "text": "Mısır mitolojisinde Büyü ve Şifa Tanrıçası kimdir?",
      "options": [
        "Isis",
        "Bastet",
        "Amun",
        "Ptah"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_3",
      "text": "Mısır mitolojisinde Cenaze ve Mumyalama Tanrısı (Çakal Başlı) kimdir?",
      "options": [
        "Ptah",
        "Bastet",
        "Amun",
        "Anubis"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_4",
      "text": "Mısır mitolojisinde Gökyüzü Tanrısı (Şahin Başlı) kimdir?",
      "options": [
        "Bastet",
        "Amun",
        "Ptah",
        "Horus"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_5",
      "text": "Mısır mitolojisinde Kaos ve Çöl Tanrısı kimdir?",
      "options": [
        "Ptah",
        "Bastet",
        "Amun",
        "Seth"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_6",
      "text": "Mısır mitolojisinde Bilgelik ve Yazı Tanrısı kimdir?",
      "options": [
        "Ptah",
        "Amun",
        "Bastet",
        "Thoth"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_7",
      "text": "Mısır Mitolojisi Soru 0",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_8",
      "text": "Mısır Mitolojisi Soru 1",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_9",
      "text": "Mısır Mitolojisi Soru 2",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_10",
      "text": "Mısır Mitolojisi Soru 3",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_11",
      "text": "Mısır Mitolojisi Soru 4",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_12",
      "text": "Mısır Mitolojisi Soru 5",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_13",
      "text": "Mısır Mitolojisi Soru 6",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_14",
      "text": "Mısır Mitolojisi Soru 7",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_15",
      "text": "Mısır Mitolojisi Soru 8",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_16",
      "text": "Mısır Mitolojisi Soru 9",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_17",
      "text": "Mısır Mitolojisi Soru 10",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_18",
      "text": "Mısır Mitolojisi Soru 11",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_19",
      "text": "Mısır Mitolojisi Soru 12",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_20",
      "text": "Mısır Mitolojisi Soru 13",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_21",
      "text": "Mısır Mitolojisi Soru 14",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_22",
      "text": "Mısır Mitolojisi Soru 15",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_23",
      "text": "Mısır Mitolojisi Soru 16",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_24",
      "text": "Mısır Mitolojisi Soru 17",
      "options": [
        "D",
        "A",
        "C",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_25",
      "text": "Mısır Mitolojisi Soru 18",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_26",
      "text": "Mısır Mitolojisi Soru 19",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_27",
      "text": "Mısır Mitolojisi Soru 20",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_28",
      "text": "Mısır Mitolojisi Soru 21",
      "options": [
        "D",
        "A",
        "C",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_29",
      "text": "Mısır Mitolojisi Soru 22",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_misir_30",
      "text": "Mısır Mitolojisi Soru 23",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_31",
      "text": "Mısır Mitolojisi Soru 24",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_32",
      "text": "Mısır Mitolojisi Soru 25",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_misir_33",
      "text": "Mısır Mitolojisi Soru 26",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_misir_34",
      "text": "Mısır Mitolojisi Soru 27",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_35",
      "text": "Mısır Mitolojisi Soru 28",
      "options": [
        "D",
        "A",
        "B",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_misir_36",
      "text": "Mısır Mitolojisi Soru 29",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    }
  ],
  "mitoloji_iskandinav": [
    {
      "id": "mitoloji_iskandinav_0",
      "text": "İskandinav mitolojisinde Baş Tanrı ve Bilgelik Tanrısı olarak bilinen kavram/kişi nedir?",
      "options": [
        "Frigg",
        "Njord",
        "Odin",
        "Balder"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_1",
      "text": "İskandinav mitolojisinde Gök Gürültüsü Tanrısı olarak bilinen kavram/kişi nedir?",
      "options": [
        "Frigg",
        "Balder",
        "Njord",
        "Thor"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_2",
      "text": "İskandinav mitolojisinde Kötülük ve Hile Tanrısı olarak bilinen kavram/kişi nedir?",
      "options": [
        "Frigg",
        "Njord",
        "Loki",
        "Balder"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_3",
      "text": "İskandinav mitolojisinde Aşk ve Bereket Tanrıçası olarak bilinen kavram/kişi nedir?",
      "options": [
        "Freyja",
        "Balder",
        "Frigg",
        "Njord"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_4",
      "text": "İskandinav mitolojisinde Tanrıların Bekçisi olarak bilinen kavram/kişi nedir?",
      "options": [
        "Njord",
        "Heimdall",
        "Frigg",
        "Balder"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_5",
      "text": "İskandinav mitolojisinde Savaş ve Adalet Tanrısı olarak bilinen kavram/kişi nedir?",
      "options": [
        "Frigg",
        "Balder",
        "Tyr",
        "Njord"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_6",
      "text": "İskandinav mitolojisinde Thor'un Çekici olarak bilinen kavram/kişi nedir?",
      "options": [
        "Njord",
        "Mjolnir",
        "Balder",
        "Frigg"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_7",
      "text": "İskandinav mitolojisinde Savaşçıların Cenneti olarak bilinen kavram/kişi nedir?",
      "options": [
        "Balder",
        "Njord",
        "Valhalla",
        "Frigg"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_8",
      "text": "İskandinav mitolojisinde Kıyamet Günü olarak bilinen kavram/kişi nedir?",
      "options": [
        "Ragnarok",
        "Balder",
        "Njord",
        "Frigg"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_9",
      "text": "İskandinav Mitolojisi Soru 0",
      "options": [
        "B",
        "A",
        "D",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_10",
      "text": "İskandinav Mitolojisi Soru 1",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_11",
      "text": "İskandinav Mitolojisi Soru 2",
      "options": [
        "A",
        "D",
        "C",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_12",
      "text": "İskandinav Mitolojisi Soru 3",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_13",
      "text": "İskandinav Mitolojisi Soru 4",
      "options": [
        "D",
        "A",
        "B",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_14",
      "text": "İskandinav Mitolojisi Soru 5",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_15",
      "text": "İskandinav Mitolojisi Soru 6",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_16",
      "text": "İskandinav Mitolojisi Soru 7",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_17",
      "text": "İskandinav Mitolojisi Soru 8",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_18",
      "text": "İskandinav Mitolojisi Soru 9",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_19",
      "text": "İskandinav Mitolojisi Soru 10",
      "options": [
        "B",
        "C",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_20",
      "text": "İskandinav Mitolojisi Soru 11",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_21",
      "text": "İskandinav Mitolojisi Soru 12",
      "options": [
        "C",
        "A",
        "D",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_22",
      "text": "İskandinav Mitolojisi Soru 13",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_23",
      "text": "İskandinav Mitolojisi Soru 14",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_24",
      "text": "İskandinav Mitolojisi Soru 15",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_25",
      "text": "İskandinav Mitolojisi Soru 16",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_26",
      "text": "İskandinav Mitolojisi Soru 17",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_27",
      "text": "İskandinav Mitolojisi Soru 18",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_iskandinav_28",
      "text": "İskandinav Mitolojisi Soru 19",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_29",
      "text": "İskandinav Mitolojisi Soru 20",
      "options": [
        "A",
        "D",
        "C",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_30",
      "text": "İskandinav Mitolojisi Soru 21",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_31",
      "text": "İskandinav Mitolojisi Soru 22",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_32",
      "text": "İskandinav Mitolojisi Soru 23",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_33",
      "text": "İskandinav Mitolojisi Soru 24",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_34",
      "text": "İskandinav Mitolojisi Soru 25",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_35",
      "text": "İskandinav Mitolojisi Soru 26",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_36",
      "text": "İskandinav Mitolojisi Soru 27",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_iskandinav_37",
      "text": "İskandinav Mitolojisi Soru 28",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_38",
      "text": "İskandinav Mitolojisi Soru 29",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    }
  ],
  "mitoloji_roma": [
    {
      "id": "mitoloji_roma_0",
      "text": "Roma mitolojisinde Jüpiter, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Zeus",
        "Apollon",
        "Hermes",
        "Dionysos"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_1",
      "text": "Roma mitolojisinde Neptün, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Hermes",
        "Dionysos",
        "Poseidon",
        "Apollon"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_2",
      "text": "Roma mitolojisinde Plüton, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Hermes",
        "Apollon",
        "Hades",
        "Dionysos"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_3",
      "text": "Roma mitolojisinde Mars, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Hermes",
        "Dionysos",
        "Apollon",
        "Ares"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_4",
      "text": "Roma mitolojisinde Minerva, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Apollon",
        "Athena",
        "Hermes",
        "Dionysos"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_5",
      "text": "Roma mitolojisinde Venüs, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Apollon",
        "Hermes",
        "Aphrodite",
        "Dionysos"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_6",
      "text": "Roma Mitolojisi Soru 0",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_7",
      "text": "Roma Mitolojisi Soru 1",
      "options": [
        "D",
        "C",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_8",
      "text": "Roma Mitolojisi Soru 2",
      "options": [
        "D",
        "A",
        "B",
        "C"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_9",
      "text": "Roma Mitolojisi Soru 3",
      "options": [
        "C",
        "D",
        "B",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_10",
      "text": "Roma Mitolojisi Soru 4",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_11",
      "text": "Roma Mitolojisi Soru 5",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_12",
      "text": "Roma Mitolojisi Soru 6",
      "options": [
        "D",
        "A",
        "C",
        "B"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_13",
      "text": "Roma Mitolojisi Soru 7",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_14",
      "text": "Roma Mitolojisi Soru 8",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_15",
      "text": "Roma Mitolojisi Soru 9",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_16",
      "text": "Roma Mitolojisi Soru 10",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_17",
      "text": "Roma Mitolojisi Soru 11",
      "options": [
        "D",
        "B",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_18",
      "text": "Roma Mitolojisi Soru 12",
      "options": [
        "C",
        "B",
        "D",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_19",
      "text": "Roma Mitolojisi Soru 13",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_20",
      "text": "Roma Mitolojisi Soru 14",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_21",
      "text": "Roma Mitolojisi Soru 15",
      "options": [
        "C",
        "A",
        "B",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_22",
      "text": "Roma Mitolojisi Soru 16",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_23",
      "text": "Roma Mitolojisi Soru 17",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_24",
      "text": "Roma Mitolojisi Soru 18",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_25",
      "text": "Roma Mitolojisi Soru 19",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_26",
      "text": "Roma Mitolojisi Soru 20",
      "options": [
        "C",
        "D",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_27",
      "text": "Roma Mitolojisi Soru 21",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_28",
      "text": "Roma Mitolojisi Soru 22",
      "options": [
        "B",
        "D",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_29",
      "text": "Roma Mitolojisi Soru 23",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_30",
      "text": "Roma Mitolojisi Soru 24",
      "options": [
        "D",
        "C",
        "A",
        "B"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_31",
      "text": "Roma Mitolojisi Soru 25",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_32",
      "text": "Roma Mitolojisi Soru 26",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_roma_33",
      "text": "Roma Mitolojisi Soru 27",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_roma_34",
      "text": "Roma Mitolojisi Soru 28",
      "options": [
        "D",
        "B",
        "A",
        "C"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_35",
      "text": "Roma Mitolojisi Soru 29",
      "options": [
        "D",
        "B",
        "C",
        "A"
      ],
      "correct": 3
    }
  ],
  "gundem": [
    {
      "id": "gundem_0",
      "text": "Avrupa Birliği'nin ortak para birimi nedir?",
      "options": [
        "Orhan Pamuk",
        "Euro",
        "Alper Gezeravcı",
        "Paris"
      ],
      "correct": 1
    },
    {
      "id": "gundem_1",
      "text": "Birleşmiş Milletler'in şimdiki (veya son) genel sekreteri kimdir?",
      "options": [
        "Bitcoin",
        "SpaceX",
        "Paris",
        "Antonio Guterres"
      ],
      "correct": 3
    },
    {
      "id": "gundem_2",
      "text": "Covid-19 pandemisine yol açan virüsün tıbbi adı nedir?",
      "options": [
        "Elon Musk",
        "Togg",
        "SARS-CoV-2",
        "Almanya"
      ],
      "correct": 2
    },
    {
      "id": "gundem_3",
      "text": "Dünyanın en popüler kripto para birimi hangisidir?",
      "options": [
        "Almanya",
        "Aziz Sancar",
        "Bitcoin",
        "Baykar"
      ],
      "correct": 2
    },
    {
      "id": "gundem_4",
      "text": "Twitter'ı satın alarak adını 'X' olarak değiştiren milyarder kimdir?",
      "options": [
        "Mark Zuckerberg",
        "2022",
        "Togg",
        "Elon Musk"
      ],
      "correct": 3
    },
    {
      "id": "gundem_5",
      "text": "Metaverse kavramıyla şirketinin adını Meta olarak değiştiren teknoloji devi kimdir?",
      "options": [
        "Baykar",
        "Alper Gezeravcı",
        "Arjantin",
        "Mark Zuckerberg"
      ],
      "correct": 3
    },
    {
      "id": "gundem_6",
      "text": "Dünyanın en yüksek binası olan Burç Halife hangi şehirdedir?",
      "options": [
        "Bitcoin",
        "Dubai",
        "2022",
        "Elon Musk"
      ],
      "correct": 1
    },
    {
      "id": "gundem_7",
      "text": "Son yılların en popüler yapay zeka arayüzü ChatGPT'yi hangi şirket geliştirmiştir?",
      "options": [
        "OpenAI",
        "Bitcoin",
        "Arjantin",
        "Paris"
      ],
      "correct": 0
    },
    {
      "id": "gundem_8",
      "text": "Türkiye'nin ilk yerli otomobil markasının adı nedir?",
      "options": [
        "Almanya",
        "Togg",
        "Arjantin",
        "Elon Musk"
      ],
      "correct": 1
    },
    {
      "id": "gundem_9",
      "text": "Türkiye'nin ilk insansız savaş uçağının adı nedir?",
      "options": [
        "Orhan Pamuk",
        "Bitcoin",
        "Kızılelma",
        "Togg"
      ],
      "correct": 2
    },
    {
      "id": "gundem_10",
      "text": "Türkiye'nin amfibi hücum gemisi ve dünyanın ilk SİHA gemisi nedir?",
      "options": [
        "Paris",
        "Aziz Sancar",
        "Arjantin",
        "TCG Anadolu"
      ],
      "correct": 3
    },
    {
      "id": "gundem_11",
      "text": "Dünyanın en zengin insanları listesinde sıkça 1. sırada yer alan Tesla ve SpaceX'in kurucusu kimdir?",
      "options": [
        "Baykar",
        "Elon Musk",
        "Orhan Pamuk",
        "OpenAI"
      ],
      "correct": 1
    },
    {
      "id": "gundem_12",
      "text": "2022 Dünya Kupası'nı kazanan ülke hangisidir?",
      "options": [
        "Kızılelma",
        "Bitcoin",
        "Arjantin",
        "2022"
      ],
      "correct": 2
    },
    {
      "id": "gundem_13",
      "text": "2024 Avrupa Futbol Şampiyonası (EURO 2024) hangi ülkede düzenlenecektir/düzenlenmiştir?",
      "options": [
        "Paris",
        "Arjantin",
        "SpaceX",
        "Almanya"
      ],
      "correct": 3
    },
    {
      "id": "gundem_14",
      "text": "2024 Yaz Olimpiyatları hangi şehirde düzenlenecektir/düzenlenmiştir?",
      "options": [
        "Mark Zuckerberg",
        "Paris",
        "Almanya",
        "Kızılelma"
      ],
      "correct": 1
    },
    {
      "id": "gundem_15",
      "text": "Rusya-Ukrayna savaşı hangi yıl başlamıştır?",
      "options": [
        "SpaceX",
        "2022",
        "Bitcoin",
        "Baykar"
      ],
      "correct": 1
    },
    {
      "id": "gundem_16",
      "text": "Türkiye'de büyük yıkıma yol açan 'Asrın Felaketi' olarak anılan Kahramanmaraş depremleri hangi tarihte olmuştur?",
      "options": [
        "Aziz Sancar",
        "Paris",
        "6 Şubat 2023",
        "Alper Gezeravcı"
      ],
      "correct": 2
    },
    {
      "id": "gundem_17",
      "text": "Karadeniz'de keşfedilen Türkiye'nin en büyük doğal gaz rezervi hangi gaz sahasındadır?",
      "options": [
        "Sakarya Gaz Sahası",
        "Bitcoin",
        "SpaceX",
        "Almanya"
      ],
      "correct": 0
    },
    {
      "id": "gundem_18",
      "text": "Nobel Edebiyat Ödülü alan ilk ve tek Türk yazar kimdir?",
      "options": [
        "Paris",
        "Orhan Pamuk",
        "Alper Gezeravcı",
        "Baykar"
      ],
      "correct": 1
    },
    {
      "id": "gundem_19",
      "text": "Nobel Kimya Ödülü alan ilk ve tek Türk bilim insanı kimdir?",
      "options": [
        "Aziz Sancar",
        "Paris",
        "SpaceX",
        "Bitcoin"
      ],
      "correct": 0
    },
    {
      "id": "gundem_20",
      "text": "İngiltere'de Kraliçe II. Elizabeth'in ardından tahta geçen kral kimdir?",
      "options": [
        "Mark Zuckerberg",
        "2022",
        "Paris",
        "III. Charles"
      ],
      "correct": 3
    },
    {
      "id": "gundem_21",
      "text": "Türkiye'nin uzaya giden ilk astronotu kimdir?",
      "options": [
        "TikTok",
        "Orhan Pamuk",
        "Mark Zuckerberg",
        "Alper Gezeravcı"
      ],
      "correct": 3
    },
    {
      "id": "gundem_22",
      "text": "2020 Olimpiyatlarında okçuluk alanında altın madalya kazanan milli sporcumuz kimdir?",
      "options": [
        "Baykar",
        "Orhan Pamuk",
        "Aziz Sancar",
        "Mete Gazoz"
      ],
      "correct": 3
    },
    {
      "id": "gundem_23",
      "text": "Kadın Voleybol Milli Takımımız (Filenin Sultanları) 2023 yılında hangi kupayı kazanarak dünya 1.si olmuştur?",
      "options": [
        "Aziz Sancar",
        "Elon Musk",
        "Alper Gezeravcı",
        "Milletler Ligi (VNL)"
      ],
      "correct": 3
    },
    {
      "id": "gundem_24",
      "text": "Dünyanın en uzun asma köprüsü olan Çanakkale köprüsünün adı nedir?",
      "options": [
        "1915 Çanakkale Köprüsü",
        "Baykar",
        "Orhan Pamuk",
        "Arjantin"
      ],
      "correct": 0
    },
    {
      "id": "gundem_25",
      "text": "Dünya Sağlık Örgütü'nün (WHO) İngilizce kısaltması nedir?",
      "options": [
        "WHO",
        "Mark Zuckerberg",
        "Bitcoin",
        "Aziz Sancar"
      ],
      "correct": 0
    },
    {
      "id": "gundem_26",
      "text": "Kuzey Atlantik İttifakı olarak bilinen ve son yıllarda genişleyen uluslararası örgüt nedir?",
      "options": [
        "Arjantin",
        "Bitcoin",
        "NATO",
        "Togg"
      ],
      "correct": 2
    },
    {
      "id": "gundem_27",
      "text": "Kripto para piyasasında değerlenen ve şaka olarak başlayıp fenomene dönüşen altcoin hangisidir?",
      "options": [
        "2022",
        "Almanya",
        "Baykar",
        "Dogecoin"
      ],
      "correct": 3
    },
    {
      "id": "gundem_28",
      "text": "SpaceX'in Mars'a gitmesi için tasarladığı dev roketin adı nedir?",
      "options": [
        "Alper Gezeravcı",
        "Starship",
        "SpaceX",
        "Orhan Pamuk"
      ],
      "correct": 1
    },
    {
      "id": "gundem_29",
      "text": "Gelecekte insanların beyinleriyle bilgisayarları bağlamayı amaçlayan Elon Musk projesi nedir?",
      "options": [
        "Neuralink",
        "2022",
        "Almanya",
        "Elon Musk"
      ],
      "correct": 0
    },
    {
      "id": "gundem_30",
      "text": "Hangi ülke 2023 yılında Ay'ın güney kutbuna başarıyla iniş yaparak tarihe geçmiştir?",
      "options": [
        "Togg",
        "Hindistan",
        "2022",
        "Alper Gezeravcı"
      ],
      "correct": 1
    },
    {
      "id": "gundem_31",
      "text": "Mona Lisa tablosu Fransa'nın hangi meşhur müzesinde sergilenmektedir?",
      "options": [
        "Louvre Müzesi",
        "Togg",
        "Paris",
        "SpaceX"
      ],
      "correct": 0
    },
    {
      "id": "gundem_32",
      "text": "İklim aktivisti olarak dünya çapında tanınan İsveçli genç kimdir?",
      "options": [
        "Elon Musk",
        "Alper Gezeravcı",
        "Greta Thunberg",
        "Orhan Pamuk"
      ],
      "correct": 2
    },
    {
      "id": "gundem_33",
      "text": "Dünyanın ilk silahlı insansız hava aracı (SİHA) üreten Türk şirketi hangisidir?",
      "options": [
        "Bitcoin",
        "Mark Zuckerberg",
        "Baykar",
        "Elon Musk"
      ],
      "correct": 2
    },
    {
      "id": "gundem_34",
      "text": "ABD'nin 46. Başkanı olarak görev yapan siyasetçi kimdir?",
      "options": [
        "2022",
        "Joe Biden",
        "Baykar",
        "Paris"
      ],
      "correct": 1
    },
    {
      "id": "gundem_35",
      "text": "Kısa videolarla tüm dünyada milyarlarca kullanıcıya ulaşan sosyal medya platformu hangisidir?",
      "options": [
        "TikTok",
        "Arjantin",
        "Togg",
        "Alper Gezeravcı"
      ],
      "correct": 0
    },
    {
      "id": "gundem_36",
      "text": "Yeniden kullanılabilir roketleriyle uzay endüstrisinde devrim yaratan şirket hangisidir?",
      "options": [
        "Elon Musk",
        "Togg",
        "Bitcoin",
        "SpaceX"
      ],
      "correct": 3
    },
    {
      "id": "gundem_37",
      "text": "Elektrikli araç üretiminde dünya lideri konumuna yükselen Çinli otomotiv markası hangisidir?",
      "options": [
        "BYD",
        "Paris",
        "Mark Zuckerberg",
        "Baykar"
      ],
      "correct": 0
    },
    {
      "id": "gundem_38",
      "text": "Türkiye'nin uzay çalışmalarını yürüten kurumun (TUA) açılımı nedir?",
      "options": [
        "Orhan Pamuk",
        "Togg",
        "Türkiye Uzay Ajansı",
        "Elon Musk"
      ],
      "correct": 2
    },
    {
      "id": "gundem_39",
      "text": "2023 yılında Twitter'ın ikonik kuş logosu hangi harf ile değiştirilmiştir?",
      "options": [
        "Arjantin",
        "Almanya",
        "X",
        "Aziz Sancar"
      ],
      "correct": 2
    }
  ],
  "din": [
    {
      "id": "din_0",
      "text": "Dini inanışlara göre 'İslam'ın kutsal kitabı' hangisidir/kimdir?",
      "options": [
        "Hz. İsa",
        "Tevrat",
        "Vatikan",
        "Kuran-ı Kerim"
      ],
      "correct": 3
    },
    {
      "id": "din_1",
      "text": "Dini inanışlara göre 'Hristiyanlığın kutsal kitabı' hangisidir/kimdir?",
      "options": [
        "Reenkarnasyon",
        "Nirvana",
        "Cebrail",
        "İncil"
      ],
      "correct": 3
    },
    {
      "id": "din_2",
      "text": "Dini inanışlara göre 'Museviliğin kutsal kitabı' hangisidir/kimdir?",
      "options": [
        "Hz. İsa",
        "Tevrat",
        "Şintoizm",
        "Nirvana"
      ],
      "correct": 1
    },
    {
      "id": "din_3",
      "text": "Dini inanışlara göre 'İslam inancına göre vahiy meleği' hangisidir/kimdir?",
      "options": [
        "Cebrail",
        "Reenkarnasyon",
        "Sinagog / Havra",
        "Vatikan"
      ],
      "correct": 0
    },
    {
      "id": "din_4",
      "text": "Dini inanışlara göre 'Doğa olaylarını düzenleyen melek' hangisidir/kimdir?",
      "options": [
        "Şintoizm",
        "Mikail",
        "Hz. Nuh",
        "Sinagog / Havra"
      ],
      "correct": 1
    },
    {
      "id": "din_5",
      "text": "Dini inanışlara göre 'Kıyamet günü sura üfleyecek olan melek' hangisidir/kimdir?",
      "options": [
        "Hz. Nuh",
        "Şintoizm",
        "Kuran-ı Kerim",
        "İsrafil"
      ],
      "correct": 3
    },
    {
      "id": "din_6",
      "text": "Dini inanışlara göre 'Ölüm meleği' hangisidir/kimdir?",
      "options": [
        "Reenkarnasyon",
        "Azrail",
        "Kuran-ı Kerim",
        "Haham"
      ],
      "correct": 1
    },
    {
      "id": "din_7",
      "text": "Kabe hangi şehirdedir?",
      "options": [
        "Tevrat",
        "Mekke",
        "Hz. Nuh",
        "Reenkarnasyon"
      ],
      "correct": 1
    },
    {
      "id": "din_8",
      "text": "Mescid-i Nebevi hangi şehirdedir?",
      "options": [
        "Medine",
        "Sinagog / Havra",
        "Kuran-ı Kerim",
        "Hz. İsa"
      ],
      "correct": 0
    },
    {
      "id": "din_9",
      "text": "Mescid-i Aksa hangi şehirdedir?",
      "options": [
        "Kudüs",
        "Kuran-ı Kerim",
        "Cebrail",
        "Hz. İsa"
      ],
      "correct": 0
    },
    {
      "id": "din_10",
      "text": "Dini inanışlara göre 'İslam'da ilk ezanı okuyan sahabe' hangisidir/kimdir?",
      "options": [
        "Tevrat",
        "Bilal-i Habeşi",
        "Tavaf",
        "Reenkarnasyon"
      ],
      "correct": 1
    },
    {
      "id": "din_11",
      "text": "Dini inanışlara göre 'Gemisiyle tufandan kurtulan peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. İsa",
        "Hz. Ömer",
        "Hz. Nuh",
        "Reenkarnasyon"
      ],
      "correct": 2
    },
    {
      "id": "din_12",
      "text": "Dini inanışlara göre 'Ateşe atıldığına ve yanmadığına inanılan peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. Nuh",
        "Cebrail",
        "Hz. Ömer",
        "Hz. İbrahim"
      ],
      "correct": 3
    },
    {
      "id": "din_13",
      "text": "Dini inanışlara göre 'Kızıldeniz'i asasıyla ikiye yaran peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. Musa",
        "Hz. Nuh",
        "Sinagog / Havra",
        "Şintoizm"
      ],
      "correct": 0
    },
    {
      "id": "din_14",
      "text": "Dini inanışlara göre 'Babası olmadan doğduğuna inanılan peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. İsa",
        "Sinagog / Havra",
        "Nirvana",
        "Cebrail"
      ],
      "correct": 0
    },
    {
      "id": "din_15",
      "text": "Dini inanışlara göre 'Balığın karnında günlerce yaşayan peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. Yunus",
        "Kuran-ı Kerim",
        "Hz. Ömer",
        "Nirvana"
      ],
      "correct": 0
    },
    {
      "id": "din_16",
      "text": "Dini inanışlara göre 'Kardeşleri tarafından kuyuya atılan peygamber' hangisidir/kimdir?",
      "options": [
        "Haham",
        "Hz. Yusuf",
        "Şintoizm",
        "Vatikan"
      ],
      "correct": 1
    },
    {
      "id": "din_17",
      "text": "Dini inanışlara göre 'Sabrıyla tanınan peygamber' hangisidir/kimdir?",
      "options": [
        "Nirvana",
        "Sinagog / Havra",
        "Reenkarnasyon",
        "Hz. Eyyüb"
      ],
      "correct": 3
    },
    {
      "id": "din_18",
      "text": "Dini inanışlara göre 'Sesinin çok güzel olduğuna ve demiri eliyle şekillendirdiğine inanılan peygamber' hangisidir/kimdir?",
      "options": [
        "Şintoizm",
        "Hz. Davud",
        "Sinagog / Havra",
        "Cebrail"
      ],
      "correct": 1
    },
    {
      "id": "din_19",
      "text": "Dini inanışlara göre 'Hayvanların dilinden anlayan ve rüzgara hükmeden peygamber' hangisidir/kimdir?",
      "options": [
        "Hz. Süleyman",
        "Kuran-ı Kerim",
        "Hz. İsa",
        "Vatikan"
      ],
      "correct": 0
    },
    {
      "id": "din_20",
      "text": "Dini inanışlara göre 'İslam'ın ilk halifesi' hangisidir/kimdir?",
      "options": [
        "Sinagog / Havra",
        "Tavaf",
        "Hz. Ebubekir",
        "Cebrail"
      ],
      "correct": 2
    },
    {
      "id": "din_21",
      "text": "Dini inanışlara göre 'Adaletiyle ünlü ikinci halife' hangisidir/kimdir?",
      "options": [
        "Hz. Ömer",
        "Mekke",
        "Hz. Nuh",
        "Araf"
      ],
      "correct": 0
    },
    {
      "id": "din_22",
      "text": "Dini inanışlara göre 'Kuran-ı Kerim'i çoğaltan üçüncü halife' hangisidir/kimdir?",
      "options": [
        "Tavaf",
        "Nirvana",
        "Hz. Nuh",
        "Hz. Osman"
      ],
      "correct": 3
    },
    {
      "id": "din_23",
      "text": "Dini inanışlara göre 'İlim şehri'nin kapısı dördüncü halife' hangisidir/kimdir?",
      "options": [
        "Hz. Ali",
        "Hz. Ömer",
        "Tavaf",
        "Vatikan"
      ],
      "correct": 0
    },
    {
      "id": "din_24",
      "text": "Dini inanışlara göre 'İslam'da inancın temeli olan kelime-i şehadetin anlamı' hangisidir/kimdir?",
      "options": [
        "Şahitlik etmek",
        "Tevrat",
        "Mekke",
        "Kuran-ı Kerim"
      ],
      "correct": 0
    },
    {
      "id": "din_25",
      "text": "Dini inanışlara göre 'Müslümanların oruç tuttuğu kutsal ay' hangisidir/kimdir?",
      "options": [
        "Ramazan",
        "Cebrail",
        "Vatikan",
        "Nirvana"
      ],
      "correct": 0
    },
    {
      "id": "din_26",
      "text": "Dini inanışlara göre 'Kabe'nin etrafında 7 kez dönmeye ne ad verilir' hangisidir/kimdir?",
      "options": [
        "Tavaf",
        "Hz. Ömer",
        "Tevrat",
        "Araf"
      ],
      "correct": 0
    },
    {
      "id": "din_27",
      "text": "Dini inanışlara göre 'Safa ile Merve tepeleri arasında gidip gelmeye ne ad verilir' hangisidir/kimdir?",
      "options": [
        "Mekke",
        "Haham",
        "Kuran-ı Kerim",
        "Sa'y"
      ],
      "correct": 3
    },
    {
      "id": "din_28",
      "text": "Dini inanışlara göre 'Müslümanların kıblesi' hangisidir/kimdir?",
      "options": [
        "Kabe",
        "Cebrail",
        "Tavaf",
        "Hz. Ömer"
      ],
      "correct": 0
    },
    {
      "id": "din_29",
      "text": "Dini inanışlara göre 'Hristiyanlıktaki üçlü inanç sistemi (Teslis)' hangisidir/kimdir?",
      "options": [
        "Hz. Ömer",
        "Tavaf",
        "Cebrail",
        "Baba, Oğul, Kutsal Ruh"
      ],
      "correct": 3
    },
    {
      "id": "din_30",
      "text": "Dini inanışlara göre 'Hristiyanların ruhani lideri Papa nerede yaşar' hangisidir/kimdir?",
      "options": [
        "Reenkarnasyon",
        "Vatikan",
        "Haham",
        "Tavaf"
      ],
      "correct": 1
    },
    {
      "id": "din_31",
      "text": "Dini inanışlara göre 'Musevilerin ibadet ettiği yere ne ad verilir' hangisidir/kimdir?",
      "options": [
        "Mekke",
        "Sinagog / Havra",
        "Kuran-ı Kerim",
        "Cebrail"
      ],
      "correct": 1
    },
    {
      "id": "din_32",
      "text": "Dini inanışlara göre 'Musevilikte din adamlarına ne ad verilir' hangisidir/kimdir?",
      "options": [
        "Haham",
        "Kuran-ı Kerim",
        "Mekke",
        "Tevrat"
      ],
      "correct": 0
    },
    {
      "id": "din_33",
      "text": "Dini inanışlara göre 'Hinduizm'de ruhun ölümden sonra başka bedene geçmesi' hangisidir/kimdir?",
      "options": [
        "Tevrat",
        "Reenkarnasyon",
        "Mekke",
        "Vatikan"
      ],
      "correct": 1
    },
    {
      "id": "din_34",
      "text": "Dini inanışlara göre 'Budizm'in kurucusu sayılan kişi' hangisidir/kimdir?",
      "options": [
        "Şintoizm",
        "Siddhartha Gautama (Buda)",
        "Tevrat",
        "Nirvana"
      ],
      "correct": 1
    },
    {
      "id": "din_35",
      "text": "Dini inanışlara göre 'Budizm'de ulaşılan en yüksek aydınlanma seviyesi' hangisidir/kimdir?",
      "options": [
        "Şintoizm",
        "Vatikan",
        "Nirvana",
        "Sinagog / Havra"
      ],
      "correct": 2
    },
    {
      "id": "din_36",
      "text": "Dini inanışlara göre 'Zerdüştlük dininde iyilik tanrısı' hangisidir/kimdir?",
      "options": [
        "Tevrat",
        "Ahura Mazda",
        "Tavaf",
        "Mekke"
      ],
      "correct": 1
    },
    {
      "id": "din_37",
      "text": "Dini inanışlara göre 'Mecusilerin kutsal sayıp taptıkları nesne' hangisidir/kimdir?",
      "options": [
        "Cebrail",
        "Şintoizm",
        "Ateş",
        "Haham"
      ],
      "correct": 2
    },
    {
      "id": "din_38",
      "text": "Dini inanışlara göre 'Japonya'nın milli dini' hangisidir/kimdir?",
      "options": [
        "Haham",
        "Mekke",
        "Şintoizm",
        "Kuran-ı Kerim"
      ],
      "correct": 2
    },
    {
      "id": "din_39",
      "text": "Dini inanışlara göre 'Eski Mısır'da güneş tanrısı' hangisidir/kimdir?",
      "options": [
        "Tavaf",
        "Nirvana",
        "Hz. Ömer",
        "Ra"
      ],
      "correct": 3
    }
  ],
  "edebiyat": [
    {
      "id": "edebiyat_0",
      "text": "'Suç ve Ceza' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Balzac",
        "Yusuf Atılgan",
        "Sabahattin Ali",
        "Dostoyevski"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_1",
      "text": "'Savaş ve Barış' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Dostoyevski",
        "Cervantes",
        "Tolstoy",
        "Franz Kafka"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_2",
      "text": "'Sefiller' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Reşat Nuri Güntekin",
        "Tolstoy",
        "Yaşar Kemal",
        "Victor Hugo"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_3",
      "text": "'Kürk Mantolu Madonna' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Yusuf Atılgan",
        "Sabahattin Ali",
        "Gustave Flaubert",
        "Emily Bronte"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_4",
      "text": "'İnce Memed' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Stendhal",
        "Aldous Huxley",
        "Yaşar Kemal",
        "Recaizade Mahmut Ekrem"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_5",
      "text": "'Tutunamayanlar' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Recaizade Mahmut Ekrem",
        "F. Scott Fitzgerald",
        "Oğuz Atay",
        "Goethe"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_6",
      "text": "'Saatleri Ayarlama Enstitüsü' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Gustave Flaubert",
        "Herman Melville",
        "Ahmet Hamdi Tanpınar",
        "Emily Bronte"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_7",
      "text": "'Masumiyet Müzesi' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Orhan Pamuk",
        "Franz Kafka",
        "Gabriel Garcia Marquez",
        "Jane Austen"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_8",
      "text": "'Faust' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Goethe",
        "Harper Lee",
        "Cervantes",
        "Franz Kafka"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_9",
      "text": "'Hamlet' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Halide Edip Adıvar",
        "Gustave Flaubert",
        "Shakespeare",
        "Oğuz Atay"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_10",
      "text": "'Dönüşüm' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Franz Kafka",
        "Dostoyevski",
        "Charlotte Bronte",
        "Peyami Safa"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_11",
      "text": "'Yabancı' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Zülfü Livaneli",
        "Gustave Flaubert",
        "Stendhal",
        "Albert Camus"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_12",
      "text": "'Yüzyıllık Yalnızlık' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Peyami Safa",
        "Orhan Pamuk",
        "Mehmet Rauf",
        "Gabriel Garcia Marquez"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_13",
      "text": "'Don Kişot' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Yaşar Kemal",
        "Victor Hugo",
        "Cervantes",
        "Oğuz Atay"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_14",
      "text": "'İlahi Komedi' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Dostoyevski",
        "Dante",
        "Yusuf Atılgan",
        "Reşat Nuri Güntekin"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_15",
      "text": "'Aşk-ı Memnu' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Reşat Nuri Güntekin",
        "Shakespeare",
        "Peyami Safa",
        "Halit Ziya Uşaklıgil"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_16",
      "text": "'Çalıkuşu' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Zülfü Livaneli",
        "Kemal Tahir",
        "Albert Camus",
        "Reşat Nuri Güntekin"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_17",
      "text": "'Eylül' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Mehmet Rauf",
        "Shakespeare",
        "Stendhal",
        "Franz Kafka"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_18",
      "text": "'Araba Sevdası' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Recaizade Mahmut Ekrem",
        "Herman Melville",
        "Peyami Safa",
        "Reşat Nuri Güntekin"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_19",
      "text": "'Sinekli Bakkal' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Tolstoy",
        "Yaşar Kemal",
        "Halide Edip Adıvar",
        "Emily Bronte"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_20",
      "text": "'Aylak Adam' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Zülfü Livaneli",
        "Yusuf Atılgan",
        "Gabriel Garcia Marquez",
        "Sabahattin Ali"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_21",
      "text": "'Puslu Kıtalar Atlası' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Charlotte Bronte",
        "İhsan Oktay Anar",
        "Stendhal",
        "Sabahattin Ali"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_22",
      "text": "'Serenad' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Kemal Tahir",
        "Zülfü Livaneli",
        "Halit Ziya Uşaklıgil",
        "F. Scott Fitzgerald"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_23",
      "text": "'Devlet Ana' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Kemal Tahir",
        "F. Scott Fitzgerald",
        "Halide Edip Adıvar",
        "Zülfü Livaneli"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_24",
      "text": "'Dokuzuncu Hariciye Koğuşu' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Zülfü Livaneli",
        "Cervantes",
        "Peyami Safa",
        "Ahmet Hamdi Tanpınar"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_25",
      "text": "'Kuyucaklı Yusuf' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Sabahattin Ali",
        "Orhan Pamuk",
        "Ahmet Hamdi Tanpınar",
        "Dostoyevski"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_26",
      "text": "'Madam Bovary' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Albert Camus",
        "Peyami Safa",
        "Shakespeare",
        "Gustave Flaubert"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_27",
      "text": "'Anna Karenina' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Jane Austen",
        "Harper Lee",
        "Tolstoy",
        "F. Scott Fitzgerald"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_28",
      "text": "'Karamazov Kardeşler' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Albert Camus",
        "George Orwell",
        "Dostoyevski",
        "Kemal Tahir"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_29",
      "text": "'Vadideki Zambak' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Jane Austen",
        "Balzac",
        "Victor Hugo",
        "Reşat Nuri Güntekin"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_30",
      "text": "'Notre Dame'ın Kamburu' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Shakespeare",
        "Dostoyevski",
        "Victor Hugo",
        "Ahmet Hamdi Tanpınar"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_31",
      "text": "'Kırmızı ve Siyah' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Stendhal",
        "Ahmet Hamdi Tanpınar",
        "Kemal Tahir",
        "Charlotte Bronte"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_32",
      "text": "'1984' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Gabriel Garcia Marquez",
        "Aldous Huxley",
        "George Orwell",
        "Balzac"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_33",
      "text": "'Hayvan Çiftliği' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Stendhal",
        "Recaizade Mahmut Ekrem",
        "Peyami Safa",
        "George Orwell"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_34",
      "text": "'Cesur Yeni Dünya' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Aldous Huxley",
        "Charlotte Bronte",
        "Yaşar Kemal",
        "Victor Hugo"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_35",
      "text": "'Bülbülü Öldürmek' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Ahmet Hamdi Tanpınar",
        "Herman Melville",
        "Harper Lee",
        "Oğuz Atay"
      ],
      "correct": 2
    },
    {
      "id": "edebiyat_36",
      "text": "'Moby Dick' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Herman Melville",
        "Gabriel Garcia Marquez",
        "Dante",
        "Jane Austen"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_37",
      "text": "'Muhteşem Gatsby' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Victor Hugo",
        "F. Scott Fitzgerald",
        "Kemal Tahir",
        "Mehmet Rauf"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_38",
      "text": "'Gurur ve Önyargı' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Jane Austen",
        "İhsan Oktay Anar",
        "Stendhal",
        "F. Scott Fitzgerald"
      ],
      "correct": 0
    },
    {
      "id": "edebiyat_39",
      "text": "'Uğultulu Tepeler' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Goethe",
        "Herman Melville",
        "Dante",
        "Emily Bronte"
      ],
      "correct": 3
    }
  ],
  "psikoloji": [
    {
      "id": "psikoloji_0",
      "text": "'Psikanaliz' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Erik Erikson",
        "Aaron Beck",
        "Sigmund Freud",
        "John B. Watson"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_1",
      "text": "'Klasik Koşullanma' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Ivan Pavlov",
        "Sigmund Freud",
        "Viktor Frankl",
        "Abraham Maslow"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_2",
      "text": "'Edimsel Koşullanma' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Abraham Maslow",
        "B.F. Skinner",
        "Carl Rogers",
        "John B. Watson"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_3",
      "text": "'İhtiyaçlar Hiyerarşisi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "B.F. Skinner",
        "Ivan Pavlov",
        "Wilhelm Wundt",
        "Abraham Maslow"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_4",
      "text": "'Analitik Psikoloji' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Ivan Pavlov",
        "Carl Jung",
        "Wilhelm Wundt",
        "John B. Watson"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_5",
      "text": "'Bilişsel Gelişim' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "John B. Watson",
        "Sigmund Freud",
        "Aaron Beck",
        "Jean Piaget"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_6",
      "text": "'Sosyal Öğrenme' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Albert Bandura",
        "B.F. Skinner",
        "Aaron Beck",
        "Carl Jung"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_7",
      "text": "'Bireysel Psikoloji' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Sigmund Freud",
        "Alfred Adler",
        "Albert Bandura",
        "Ivan Pavlov"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_8",
      "text": "'İnsancıl Psikoloji' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "B.F. Skinner",
        "Carl Rogers",
        "Wilhelm Wundt",
        "Erik Erikson"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_9",
      "text": "'Psikososyal Gelişim' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "John B. Watson",
        "Erik Erikson",
        "Carl Jung",
        "Viktor Frankl"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_10",
      "text": "'İd, Ego, Süperego' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Albert Bandura",
        "Sigmund Freud",
        "Jean Piaget",
        "Erik Erikson"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_11",
      "text": "'Savunma Mekanizmaları' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Anna Freud",
        "Albert Bandura",
        "Sigmund Freud",
        "Abraham Maslow"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_12",
      "text": "'Kolektif Bilinçdışı' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "B.F. Skinner",
        "John B. Watson",
        "Viktor Frankl",
        "Carl Jung"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_13",
      "text": "'Aşağılık Kompleksi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Abraham Maslow",
        "Alfred Adler",
        "Jean Piaget",
        "Ivan Pavlov"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_14",
      "text": "'Kendini Gerçekleştirme' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Erik Erikson",
        "Carl Jung",
        "Abraham Maslow",
        "Ivan Pavlov"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_15",
      "text": "'Gestalt Psikolojisi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Max Wertheimer",
        "Sigmund Freud",
        "Erik Erikson",
        "Jean Piaget"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_16",
      "text": "'Deneysel Psikolojinin Kurucusu' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "John B. Watson",
        "Carl Jung",
        "Jean Piaget",
        "Wilhelm Wundt"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_17",
      "text": "'Davranışçılık Kurucusu' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Albert Bandura",
        "Aaron Beck",
        "John B. Watson",
        "B.F. Skinner"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_18",
      "text": "'Logoterapi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Albert Bandura",
        "Viktor Frankl",
        "Carl Jung",
        "Abraham Maslow"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_19",
      "text": "'Bilişsel Terapi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Albert Bandura",
        "Ivan Pavlov",
        "Sigmund Freud",
        "Aaron Beck"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_20",
      "text": "'Akılcı Duygusal Terapi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Carl Jung",
        "John B. Watson",
        "Albert Ellis",
        "Wilhelm Wundt"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_21",
      "text": "'Bağlanma Kuramı' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Sigmund Freud",
        "Jean Piaget",
        "Carl Jung",
        "John Bowlby"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_22",
      "text": "'Bebeklerde Bağlanma' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "John B. Watson",
        "Mary Ainsworth",
        "Carl Jung",
        "Ivan Pavlov"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_23",
      "text": "'Çoklu Zeka Kuramı' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Jean Piaget",
        "Howard Gardner",
        "B.F. Skinner",
        "Albert Bandura"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_24",
      "text": "'Duygusal Zeka' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Daniel Goleman",
        "John B. Watson",
        "B.F. Skinner",
        "Carl Jung"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_25",
      "text": "'Küçük Albert Deneyi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Sigmund Freud",
        "John B. Watson",
        "Abraham Maslow",
        "Ivan Pavlov"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_26",
      "text": "'Milgram İtaat Deneyi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Abraham Maslow",
        "Albert Bandura",
        "Stanley Milgram",
        "Sigmund Freud"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_27",
      "text": "'Stanford Hapishane Deneyi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Erik Erikson",
        "B.F. Skinner",
        "Philip Zimbardo",
        "Wilhelm Wundt"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_28",
      "text": "'Öğrenilmiş Çaresizlik' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Martin Seligman",
        "John B. Watson",
        "Jean Piaget",
        "Albert Bandura"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_29",
      "text": "'Ahlaki Gelişim Kuramı' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Lawrence Kohlberg",
        "Jean Piaget",
        "John B. Watson",
        "Abraham Maslow"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_30",
      "text": "'Koşulsuz Olumlu Kabul' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Carl Jung",
        "Albert Bandura",
        "Carl Rogers",
        "Erik Erikson"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_31",
      "text": "'Ayna Nöronlar' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Giacomo Rizzolatti",
        "Erik Erikson",
        "Abraham Maslow",
        "Jean Piaget"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_32",
      "text": "Psikolojide 'Plasebo Etkisi' genel olarak nasıl tanımlanır?",
      "options": [
        "İnancın İyileştirme Gücü",
        "Agorafobi",
        "Klostrofobi",
        "Şizofreni"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_33",
      "text": "Psikolojide 'Karanlık Üçlü' genel olarak nasıl tanımlanır?",
      "options": [
        "OKB",
        "Bipolar Bozukluk",
        "Narsisizm",
        "Narsisizm, Makyavelizm, Psikopati"
      ],
      "correct": 3
    },
    {
      "id": "psikoloji_34",
      "text": "Psikolojide 'Şizofreni' genel olarak nasıl tanımlanır?",
      "options": [
        "Narsisizm",
        "Klostrofobi",
        "Gerçeklikle Bağlantının Kopması",
        "OKB"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_35",
      "text": "Psikolojide 'Bipolar Bozukluk' genel olarak nasıl tanımlanır?",
      "options": [
        "Manik-Depresif Değişimler",
        "Klostrofobi",
        "Depresyon",
        "Plasebo Etkisi"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_36",
      "text": "Psikolojide 'OKB (Obsesif Kompulsif Bozukluk)' genel olarak nasıl tanımlanır?",
      "options": [
        "OKB",
        "Takıntılı Düşünce ve Davranışlar",
        "Klostrofobi",
        "Agorafobi"
      ],
      "correct": 1
    },
    {
      "id": "psikoloji_37",
      "text": "Psikolojide 'Panik Atak' genel olarak nasıl tanımlanır?",
      "options": [
        "Agorafobi",
        "Klostrofobi",
        "Ani ve Yoğun Korku Nöbeti",
        "Narsisizm"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_38",
      "text": "Psikolojide 'Depresyon' genel olarak nasıl tanımlanır?",
      "options": [
        "Panik Atak",
        "Bipolar Bozukluk",
        "Sürekli Üzüntü ve İsteksizlik",
        "Narsisizm"
      ],
      "correct": 2
    },
    {
      "id": "psikoloji_39",
      "text": "Psikolojide 'Agorafobi' genel olarak nasıl tanımlanır?",
      "options": [
        "Bipolar Bozukluk",
        "OKB",
        "Açık Alan veya Kalabalık Korkusu",
        "Plasebo Etkisi"
      ],
      "correct": 2
    }
  ],
  "sinema": [
    {
      "id": "sinema_0",
      "text": "Kült haline gelmiş 'Baba (The Godfather)' filminin yönetmeni kimdir?",
      "options": [
        "Milos Forman",
        "Jonathan Demme",
        "Martin Scorsese",
        "Francis Ford Coppola"
      ],
      "correct": 3
    },
    {
      "id": "sinema_1",
      "text": "Kült haline gelmiş 'Ucuz Roman (Pulp Fiction)' filminin yönetmeni kimdir?",
      "options": [
        "Peter Jackson",
        "Quentin Tarantino",
        "Çağan Irmak",
        "Yavuz Turgul"
      ],
      "correct": 1
    },
    {
      "id": "sinema_2",
      "text": "Kült haline gelmiş 'Başlangıç (Inception)' filminin yönetmeni kimdir?",
      "options": [
        "Martin Scorsese",
        "Ridley Scott",
        "Christopher Nolan",
        "Sergio Leone"
      ],
      "correct": 2
    },
    {
      "id": "sinema_3",
      "text": "Kült haline gelmiş 'Yüzüklerin Efendisi' filminin yönetmeni kimdir?",
      "options": [
        "Peter Jackson",
        "Milos Forman",
        "Mel Gibson",
        "Sergio Leone"
      ],
      "correct": 0
    },
    {
      "id": "sinema_4",
      "text": "Kült haline gelmiş 'Matrix' filminin yönetmeni kimdir?",
      "options": [
        "Çağan Irmak",
        "Roman Polanski",
        "Frank Darabont",
        "Wachowski Kardeşler"
      ],
      "correct": 3
    },
    {
      "id": "sinema_5",
      "text": "Kült haline gelmiş 'Kış Uykusu' filminin yönetmeni kimdir?",
      "options": [
        "Alfred Hitchcock",
        "Nuri Bilge Ceylan",
        "Roman Polanski",
        "Yavuz Turgul"
      ],
      "correct": 1
    },
    {
      "id": "sinema_6",
      "text": "Kült haline gelmiş 'Eşkıya' filminin yönetmeni kimdir?",
      "options": [
        "Çağan Irmak",
        "Christopher Nolan",
        "Bryan Singer",
        "Yavuz Turgul"
      ],
      "correct": 3
    },
    {
      "id": "sinema_7",
      "text": "Kült haline gelmiş 'Babam ve Oğlum' filminin yönetmeni kimdir?",
      "options": [
        "Çağan Irmak",
        "Martin Scorsese",
        "Bryan Singer",
        "Christopher Nolan"
      ],
      "correct": 0
    },
    {
      "id": "sinema_8",
      "text": "Kült haline gelmiş 'Geleceğe Dönüş' filminin yönetmeni kimdir?",
      "options": [
        "Steven Spielberg",
        "Robert Zemeckis",
        "Ridley Scott",
        "Christopher Nolan"
      ],
      "correct": 1
    },
    {
      "id": "sinema_9",
      "text": "Kült haline gelmiş 'Cinnet (The Shining)' filminin yönetmeni kimdir?",
      "options": [
        "Peter Jackson",
        "Bryan Singer",
        "Sergio Leone",
        "Stanley Kubrick"
      ],
      "correct": 3
    },
    {
      "id": "sinema_10",
      "text": "Kült haline gelmiş 'Schindler'in Listesi' filminin yönetmeni kimdir?",
      "options": [
        "Roman Polanski",
        "Sergio Leone",
        "Çağan Irmak",
        "Steven Spielberg"
      ],
      "correct": 3
    },
    {
      "id": "sinema_11",
      "text": "Kült haline gelmiş 'Er Ryan'ı Kurtarmak' filminin yönetmeni kimdir?",
      "options": [
        "Steven Spielberg",
        "Wachowski Kardeşler",
        "Martin Scorsese",
        "James Cameron"
      ],
      "correct": 0
    },
    {
      "id": "sinema_12",
      "text": "Kült haline gelmiş 'Yaratık (Alien)' filminin yönetmeni kimdir?",
      "options": [
        "Steven Spielberg",
        "David Fincher",
        "Ridley Scott",
        "Stanley Kubrick"
      ],
      "correct": 2
    },
    {
      "id": "sinema_13",
      "text": "Kült haline gelmiş 'Bıçak Sırtı (Blade Runner)' filminin yönetmeni kimdir?",
      "options": [
        "Mel Gibson",
        "Roman Polanski",
        "Ridley Scott",
        "David Fincher"
      ],
      "correct": 2
    },
    {
      "id": "sinema_14",
      "text": "Kült haline gelmiş 'Gladyatör' filminin yönetmeni kimdir?",
      "options": [
        "Nuri Bilge Ceylan",
        "Quentin Tarantino",
        "Ridley Scott",
        "Mel Gibson"
      ],
      "correct": 2
    },
    {
      "id": "sinema_15",
      "text": "Kült haline gelmiş 'Yıldızlararası (Interstellar)' filminin yönetmeni kimdir?",
      "options": [
        "Christopher Nolan",
        "Peter Jackson",
        "Jonathan Demme",
        "Ridley Scott"
      ],
      "correct": 0
    },
    {
      "id": "sinema_16",
      "text": "Kült haline gelmiş 'Kara Şövalye (The Dark Knight)' filminin yönetmeni kimdir?",
      "options": [
        "Frank Darabont",
        "Jonathan Demme",
        "Nuri Bilge Ceylan",
        "Christopher Nolan"
      ],
      "correct": 3
    },
    {
      "id": "sinema_17",
      "text": "Kült haline gelmiş 'Titanik' filminin yönetmeni kimdir?",
      "options": [
        "James Cameron",
        "Alfred Hitchcock",
        "Martin Scorsese",
        "Yavuz Turgul"
      ],
      "correct": 0
    },
    {
      "id": "sinema_18",
      "text": "Kült haline gelmiş 'Avatar' filminin yönetmeni kimdir?",
      "options": [
        "Peter Jackson",
        "James Cameron",
        "Sergio Leone",
        "Frank Darabont"
      ],
      "correct": 1
    },
    {
      "id": "sinema_19",
      "text": "Kült haline gelmiş 'Terminatör' filminin yönetmeni kimdir?",
      "options": [
        "Alfred Hitchcock",
        "Nuri Bilge Ceylan",
        "Steven Spielberg",
        "James Cameron"
      ],
      "correct": 3
    },
    {
      "id": "sinema_20",
      "text": "Kült haline gelmiş 'Dövüş Kulübü' filminin yönetmeni kimdir?",
      "options": [
        "James Cameron",
        "David Fincher",
        "Bryan Singer",
        "Mel Gibson"
      ],
      "correct": 1
    },
    {
      "id": "sinema_21",
      "text": "Kült haline gelmiş 'Yedi (Sevent)' filminin yönetmeni kimdir?",
      "options": [
        "Roman Polanski",
        "Alfred Hitchcock",
        "Nuri Bilge Ceylan",
        "David Fincher"
      ],
      "correct": 3
    },
    {
      "id": "sinema_22",
      "text": "Kült haline gelmiş 'Kuzuların Sessizliği' filminin yönetmeni kimdir?",
      "options": [
        "Francis Ford Coppola",
        "Ridley Scott",
        "Jonathan Demme",
        "Alfred Hitchcock"
      ],
      "correct": 2
    },
    {
      "id": "sinema_23",
      "text": "Kült haline gelmiş 'Sapık (Psycho)' filminin yönetmeni kimdir?",
      "options": [
        "Çağan Irmak",
        "Nuri Bilge Ceylan",
        "Mel Gibson",
        "Alfred Hitchcock"
      ],
      "correct": 3
    },
    {
      "id": "sinema_24",
      "text": "Kült haline gelmiş 'Arka Pencere' filminin yönetmeni kimdir?",
      "options": [
        "Mel Gibson",
        "Alfred Hitchcock",
        "Francis Ford Coppola",
        "Yavuz Turgul"
      ],
      "correct": 1
    },
    {
      "id": "sinema_25",
      "text": "Kült haline gelmiş 'İyi, Kötü ve Çirkin' filminin yönetmeni kimdir?",
      "options": [
        "Sergio Leone",
        "James Cameron",
        "Ridley Scott",
        "Wachowski Kardeşler"
      ],
      "correct": 0
    },
    {
      "id": "sinema_26",
      "text": "Kült haline gelmiş 'Bir Zamanlar Amerika' filminin yönetmeni kimdir?",
      "options": [
        "Christopher Nolan",
        "Martin Scorsese",
        "Robert Zemeckis",
        "Sergio Leone"
      ],
      "correct": 3
    },
    {
      "id": "sinema_27",
      "text": "Kült haline gelmiş 'Taksi Şoförü' filminin yönetmeni kimdir?",
      "options": [
        "Martin Scorsese",
        "Frank Darabont",
        "Bryan Singer",
        "David Fincher"
      ],
      "correct": 0
    },
    {
      "id": "sinema_28",
      "text": "Kült haline gelmiş 'Köstebek (The Departed)' filminin yönetmeni kimdir?",
      "options": [
        "Martin Scorsese",
        "Steven Spielberg",
        "David Fincher",
        "Milos Forman"
      ],
      "correct": 0
    },
    {
      "id": "sinema_29",
      "text": "Kült haline gelmiş 'Sıkı Dostlar (Goodfellas)' filminin yönetmeni kimdir?",
      "options": [
        "Jonathan Demme",
        "Alfred Hitchcock",
        "Martin Scorsese",
        "Stanley Kubrick"
      ],
      "correct": 2
    },
    {
      "id": "sinema_30",
      "text": "Kült haline gelmiş 'Olağan Şüpheliler' filminin yönetmeni kimdir?",
      "options": [
        "Francis Ford Coppola",
        "Bryan Singer",
        "Yavuz Turgul",
        "Roman Polanski"
      ],
      "correct": 1
    },
    {
      "id": "sinema_31",
      "text": "Kült haline gelmiş 'Yeşil Yol' filminin yönetmeni kimdir?",
      "options": [
        "Alfred Hitchcock",
        "Frank Darabont",
        "Nuri Bilge Ceylan",
        "Mel Gibson"
      ],
      "correct": 1
    },
    {
      "id": "sinema_32",
      "text": "Kült haline gelmiş 'Esaretin Bedeli' filminin yönetmeni kimdir?",
      "options": [
        "Nuri Bilge Ceylan",
        "Peter Jackson",
        "Frank Darabont",
        "Steven Spielberg"
      ],
      "correct": 2
    },
    {
      "id": "sinema_33",
      "text": "Kült haline gelmiş 'Guguk Kuşu' filminin yönetmeni kimdir?",
      "options": [
        "Robert Zemeckis",
        "Alfred Hitchcock",
        "Milos Forman",
        "Roman Polanski"
      ],
      "correct": 2
    },
    {
      "id": "sinema_34",
      "text": "Kült haline gelmiş 'Amadeus' filminin yönetmeni kimdir?",
      "options": [
        "James Cameron",
        "Milos Forman",
        "Robert Zemeckis",
        "Steven Spielberg"
      ],
      "correct": 1
    },
    {
      "id": "sinema_35",
      "text": "Kült haline gelmiş 'Cesur Yürek' filminin yönetmeni kimdir?",
      "options": [
        "Francis Ford Coppola",
        "Mel Gibson",
        "Nuri Bilge Ceylan",
        "Frank Darabont"
      ],
      "correct": 1
    },
    {
      "id": "sinema_36",
      "text": "Kült haline gelmiş 'Kıyamet (Apocalypse Now)' filminin yönetmeni kimdir?",
      "options": [
        "Christopher Nolan",
        "Milos Forman",
        "Francis Ford Coppola",
        "Martin Scorsese"
      ],
      "correct": 2
    },
    {
      "id": "sinema_37",
      "text": "Kült haline gelmiş 'Rezervuar Köpekleri' filminin yönetmeni kimdir?",
      "options": [
        "Milos Forman",
        "Quentin Tarantino",
        "Stanley Kubrick",
        "Bryan Singer"
      ],
      "correct": 1
    },
    {
      "id": "sinema_38",
      "text": "Kült haline gelmiş 'Zincirsiz (Django Unchained)' filminin yönetmeni kimdir?",
      "options": [
        "Peter Jackson",
        "Christopher Nolan",
        "Francis Ford Coppola",
        "Quentin Tarantino"
      ],
      "correct": 3
    },
    {
      "id": "sinema_39",
      "text": "Kült haline gelmiş 'Piyanist' filminin yönetmeni kimdir?",
      "options": [
        "Ridley Scott",
        "Peter Jackson",
        "Roman Polanski",
        "Francis Ford Coppola"
      ],
      "correct": 2
    }
  ],
  "siyaset": [
    {
      "id": "siyaset_0",
      "text": "Siyaset biliminde ve tarihinde 'Halkın egemenliğine dayanan yönetim biçimi' nedir/kimdir?",
      "options": [
        "Demokrasi",
        "Sosyalizm",
        "1946",
        "George Washington"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_1",
      "text": "Siyaset biliminde ve tarihinde 'Dini kurallara dayalı yönetim biçimi' nedir/kimdir?",
      "options": [
        "1952",
        "1989",
        "Teokrasi",
        "Sosyalizm"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_2",
      "text": "Siyaset biliminde ve tarihinde 'Soya bağlı ve ömür boyu süren yönetim biçimi' nedir/kimdir?",
      "options": [
        "Oligarşi",
        "Sosyalizm",
        "Brüksel",
        "Monarşi"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_3",
      "text": "Siyaset biliminde ve tarihinde 'Küçük ve ayrıcalıklı bir grubun iktidarı' nedir/kimdir?",
      "options": [
        "Sosyalizm",
        "Demokrasi",
        "Faşizm",
        "Oligarşi"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_4",
      "text": "Siyaset biliminde ve tarihinde 'Tek kişinin baskıcı yönetimi' nedir/kimdir?",
      "options": [
        "Oligarşi",
        "Nelson Mandela",
        "Brüksel",
        "Diktatörlük"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_5",
      "text": "Siyaset biliminde ve tarihinde 'Toplumun devletin çıkarları için tam kontrol altında tutulması' nedir/kimdir?",
      "options": [
        "Totalitarizm",
        "1989",
        "George Washington",
        "1946"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_6",
      "text": "Siyaset biliminde ve tarihinde 'Devletsiz ve otoritesiz toplum düzeni savunan görüş' nedir/kimdir?",
      "options": [
        "Mahatma Gandhi",
        "Brüksel",
        "Anarşizm",
        "George Washington"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_7",
      "text": "Siyaset biliminde ve tarihinde 'Üretim araçlarının ortak mülkiyetini savunan görüş' nedir/kimdir?",
      "options": [
        "Komünizm",
        "Mahatma Gandhi",
        "Monarşi",
        "1946"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_8",
      "text": "Siyaset biliminde ve tarihinde 'Serbest piyasa ve bireysel özgürlükleri öne çıkaran ideoloji' nedir/kimdir?",
      "options": [
        "1952",
        "Liberalizm",
        "Teokrasi",
        "1946"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_9",
      "text": "Siyaset biliminde ve tarihinde 'Gelenekleri ve mevcut düzeni korumayı amaçlayan görüş' nedir/kimdir?",
      "options": [
        "New York",
        "Muhafazakarlık",
        "Faşizm",
        "1946"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_10",
      "text": "Siyaset biliminde ve tarihinde 'Milliyetçiliği ve otoriter devleti savunan aşırı sağcı ideoloji' nedir/kimdir?",
      "options": [
        "Monarşi",
        "Faşizm",
        "Oligarşi",
        "New York"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_11",
      "text": "Siyaset biliminde ve tarihinde 'İşçi sınıfının haklarını ve sosyal adaleti savunan ideoloji' nedir/kimdir?",
      "options": [
        "1952",
        "Sosyalizm",
        "Monarşi",
        "1989"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_12",
      "text": "Siyaset biliminde ve tarihinde 'Birleşmiş Milletler'in merkezi' nedir/kimdir?",
      "options": [
        "New York",
        "Sosyalizm",
        "Oligarşi",
        "Faşizm"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_13",
      "text": "Siyaset biliminde ve tarihinde 'NATO'nun açılımı' nedir/kimdir?",
      "options": [
        "George Washington",
        "Kuzey Atlantik Antlaşması Örgütü",
        "Demokrasi",
        "Monarşi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_14",
      "text": "Siyaset biliminde ve tarihinde 'Avrupa Birliği'nin başkenti sayılan şehir' nedir/kimdir?",
      "options": [
        "New York",
        "1989",
        "Brüksel",
        "1952"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_15",
      "text": "Siyaset biliminde ve tarihinde 'ABD'nin ilk başkanı' nedir/kimdir?",
      "options": [
        "1946",
        "George Washington",
        "Teokrasi",
        "Monarşi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_16",
      "text": "Siyaset biliminde ve tarihinde 'Soğuk Savaş'ta Sovyetlerin kurduğu askeri pakt' nedir/kimdir?",
      "options": [
        "Faşizm",
        "Varşova Paktı",
        "1989",
        "Sosyalizm"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_17",
      "text": "Siyaset biliminde ve tarihinde 'Küba Devrimi'nin efsanevi lideri' nedir/kimdir?",
      "options": [
        "Teokrasi",
        "Fidel Castro",
        "Brüksel",
        "Monarşi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_18",
      "text": "Siyaset biliminde ve tarihinde 'Güney Afrika'da Apartheid rejimini yıkan lider' nedir/kimdir?",
      "options": [
        "1946",
        "Nelson Mandela",
        "Teokrasi",
        "1952"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_19",
      "text": "Siyaset biliminde ve tarihinde 'Hindistan'ın bağımsızlık lideri' nedir/kimdir?",
      "options": [
        "George Washington",
        "Faşizm",
        "Brüksel",
        "Mahatma Gandhi"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_20",
      "text": "Siyaset biliminde ve tarihinde 'Türkiye Cumhuriyeti'nin ilk başbakanı' nedir/kimdir?",
      "options": [
        "Brüksel",
        "Nelson Mandela",
        "Demokrasi",
        "İsmet İnönü"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_21",
      "text": "Siyaset biliminde ve tarihinde 'Çin Halk Cumhuriyeti'nin kurucusu' nedir/kimdir?",
      "options": [
        "Mao Zedong",
        "Oligarşi",
        "Faşizm",
        "Nelson Mandela"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_22",
      "text": "Siyaset biliminde ve tarihinde 'İngiltere'nin 'Demir Leydi' lakaplı kadın başbakanı' nedir/kimdir?",
      "options": [
        "Margaret Thatcher",
        "Faşizm",
        "Teokrasi",
        "1989"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_23",
      "text": "Siyaset biliminde ve tarihinde 'Fransa'nın 5. Cumhuriyetini kuran lider' nedir/kimdir?",
      "options": [
        "Charles de Gaulle",
        "Mahatma Gandhi",
        "1989",
        "1946"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_24",
      "text": "Siyaset biliminde ve tarihinde 'Sovyetler Birliği'nin son lideri' nedir/kimdir?",
      "options": [
        "Teokrasi",
        "1946",
        "Mihail Gorbaçov",
        "Demokrasi"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_25",
      "text": "Siyaset biliminde ve tarihinde 'Berlin Duvarı hangi yıl yıkılmıştır' nedir/kimdir?",
      "options": [
        "Faşizm",
        "1989",
        "Nelson Mandela",
        "Adnan Menderes"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_26",
      "text": "Siyaset biliminde ve tarihinde 'Magna Carta hangi ülkede imzalanmıştır' nedir/kimdir?",
      "options": [
        "İngiltere",
        "Oligarşi",
        "1952",
        "1946"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_27",
      "text": "Siyaset biliminde ve tarihinde 'TBMM hangi tarihte açılmıştır' nedir/kimdir?",
      "options": [
        "23 Nisan 1920",
        "Oligarşi",
        "1989",
        "Brüksel"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_28",
      "text": "Siyaset biliminde ve tarihinde 'Türkiye'nin çok partili hayata geçiş yılı' nedir/kimdir?",
      "options": [
        "1946",
        "Turgut Özal",
        "1952",
        "Teokrasi"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_29",
      "text": "Siyaset biliminde ve tarihinde 'Kıbrıs Barış Harekatı'nı gerçekleştiren başbakan' nedir/kimdir?",
      "options": [
        "Oligarşi",
        "Teokrasi",
        "New York",
        "Bülent Ecevit"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_30",
      "text": "Siyaset biliminde ve tarihinde '1960 darbesi sonrası idam edilen Türkiye başbakanı' nedir/kimdir?",
      "options": [
        "Demokrasi",
        "George Washington",
        "Adnan Menderes",
        "Mahatma Gandhi"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_31",
      "text": "Siyaset biliminde ve tarihinde 'Türkiye'nin 8. Cumhurbaşkanı kimdir' nedir/kimdir?",
      "options": [
        "George Washington",
        "1989",
        "Turgut Özal",
        "Teokrasi"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_32",
      "text": "Siyaset biliminde ve tarihinde 'Dünyanın en fazla nüfusa sahip ikinci ülkesi' nedir/kimdir?",
      "options": [
        "Sosyalizm",
        "1952",
        "Çin (Hindistan birinci oldu)",
        "1946"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_33",
      "text": "Siyaset biliminde ve tarihinde 'BM Güvenlik Konseyi'nin kaç daimi üyesi vardır' nedir/kimdir?",
      "options": [
        "5",
        "Mahatma Gandhi",
        "Nelson Mandela",
        "1989"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_34",
      "text": "Siyaset biliminde ve tarihinde 'Avrupa Birliği'nden ayrılan ülke (Brexit)' nedir/kimdir?",
      "options": [
        "Mahatma Gandhi",
        "Monarşi",
        "1946",
        "İngiltere"
      ],
      "correct": 3
    },
    {
      "id": "siyaset_35",
      "text": "Siyaset biliminde ve tarihinde 'Türkiye NATO'ya hangi yıl üye oldu' nedir/kimdir?",
      "options": [
        "Teokrasi",
        "1952",
        "Monarşi",
        "Demokrasi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_36",
      "text": "Siyaset biliminde ve tarihinde 'Amerika kıtasını keşfeden denizci' nedir/kimdir?",
      "options": [
        "Monarşi",
        "Oligarşi",
        "Kristof Kolomb",
        "New York"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_37",
      "text": "Siyaset biliminde ve tarihinde 'İstanbul'un Fethi' nedir/kimdir?",
      "options": [
        "Faşizm",
        "1453",
        "George Washington",
        "Monarşi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_38",
      "text": "Siyaset biliminde ve tarihinde 'Fransız İhtilali'nin yılı' nedir/kimdir?",
      "options": [
        "Faşizm",
        "George Washington",
        "1789",
        "Sosyalizm"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_39",
      "text": "Siyaset biliminde ve tarihinde 'Sanayi Devrimi nerede başlamıştır' nedir/kimdir?",
      "options": [
        "İngiltere",
        "Teokrasi",
        "1946",
        "Faşizm"
      ],
      "correct": 0
    }
  ],
  "sosyoloji": [
    {
      "id": "sosyoloji_0",
      "text": "'Sosyolojinin kurucusu ve Pozitivizmin isim babası' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "İbn Haldun",
        "Michel Foucault",
        "Auguste Comte"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_1",
      "text": "'Çatışma Kuramı ve Kapital' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Karl Marx",
        "Edward Said",
        "Jean Baudrillard",
        "Auguste Comte"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_2",
      "text": "'Toplumsal anomi ve İntihar çalışması' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Zygmunt Bauman",
        "Auguste Comte",
        "Herbert Spencer",
        "Emile Durkheim"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_3",
      "text": "'Bürokrasi ve Protestan Ahlakı' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "Pierre Bourdieu",
        "Jean Baudrillard",
        "Max Weber"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_4",
      "text": "'Mukaddime' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Pierre Bourdieu",
        "Zygmunt Bauman",
        "İbn Haldun",
        "Herbert Spencer"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_5",
      "text": "'Yabancılaşma' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Zygmunt Bauman",
        "Emile Durkheim",
        "Jean Baudrillard",
        "Karl Marx"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_6",
      "text": "'Sınıf Bilinci' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "İbn Haldun",
        "Michel Foucault",
        "Max Weber",
        "Karl Marx"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_7",
      "text": "'Mekanik ve Organik Dayanışma' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Auguste Comte",
        "Emile Durkheim",
        "Pierre Bourdieu",
        "Max Weber"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_8",
      "text": "'Otorite Tipleri (Geleneksel, Karizmatik, Yasal)' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Pierre Bourdieu",
        "Max Weber",
        "Edward Said",
        "Emile Durkheim"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_9",
      "text": "'Toplumsal Evrim' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "Karl Marx",
        "İbn Haldun",
        "Emile Durkheim"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_10",
      "text": "'Sembolik Etkileşimcilik' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Michel Foucault",
        "Zygmunt Bauman",
        "Herbert Spencer",
        "George Herbert Mead"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_11",
      "text": "'Dramaturjik Yaklaşım (Gündelik Hayatta Benliğin Sunumu)' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Erving Goffman",
        "Max Weber",
        "Herbert Spencer",
        "Zygmunt Bauman"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_12",
      "text": "'Ağ Toplumu' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Auguste Comte",
        "Pierre Bourdieu",
        "Jean Baudrillard",
        "Manuel Castells"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_13",
      "text": "'Gözetim Toplumu ve Panoptikon' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Michel Foucault",
        "Zygmunt Bauman",
        "İbn Haldun",
        "Karl Marx"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_14",
      "text": "'Kültürel Sermaye' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Karl Marx",
        "Michel Foucault",
        "Emile Durkheim",
        "Pierre Bourdieu"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_15",
      "text": "'Habitus' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Pierre Bourdieu",
        "Edward Said",
        "Karl Marx",
        "İbn Haldun"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_16",
      "text": "'Tüketim Toplumu' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Auguste Comte",
        "Zygmunt Bauman",
        "Jean Baudrillard",
        "Pierre Bourdieu"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_17",
      "text": "'Simülasyon ve Simülakr' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "Max Weber",
        "Auguste Comte",
        "Jean Baudrillard"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_18",
      "text": "'Akışkan Aşk ve Modernite' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Zygmunt Bauman",
        "Max Weber",
        "Michel Foucault",
        "Emile Durkheim"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_19",
      "text": "'Risk Toplumu' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Jean Baudrillard",
        "Ulrich Beck",
        "Emile Durkheim",
        "Auguste Comte"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_20",
      "text": "'Sosyolojik Düşünmek' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "Zygmunt Bauman",
        "İbn Haldun",
        "Georg Simmel"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_21",
      "text": "'Yabancı' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Georg Simmel",
        "Karl Marx",
        "Zygmunt Bauman",
        "Michel Foucault"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_22",
      "text": "'Metropol ve Tinsel Hayat' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "Auguste Comte",
        "Jean Baudrillard",
        "Georg Simmel"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_23",
      "text": "'Görünmez El' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "İbn Haldun",
        "Adam Smith",
        "Jean Baudrillard",
        "Karl Marx"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_24",
      "text": "'Ütopya' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "Michel Foucault",
        "Thomas More",
        "Karl Marx"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_25",
      "text": "'Leviathan' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Thomas Hobbes",
        "Emile Durkheim",
        "Herbert Spencer",
        "Michel Foucault"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_26",
      "text": "'Toplum Sözleşmesi' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Karl Marx",
        "Jean-Jacques Rousseau",
        "Zygmunt Bauman",
        "Herbert Spencer"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_27",
      "text": "'İki İnceleme' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "John Locke",
        "Pierre Bourdieu",
        "Emile Durkheim",
        "Auguste Comte"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_28",
      "text": "'Egemenlik ve Güçler Ayrılığı' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "Zygmunt Bauman",
        "İbn Haldun",
        "Montesquieu"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_29",
      "text": "'Hegemonya' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "Max Weber",
        "Michel Foucault",
        "Antonio Gramsci"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_30",
      "text": "'Madun Konuşabilir mi?' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "Jean Baudrillard",
        "Auguste Comte",
        "Gayatri Spivak"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_31",
      "text": "'Oryantalizm' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "İbn Haldun",
        "Edward Said",
        "Jean Baudrillard"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_32",
      "text": "'Madalyonun İki Yüzü' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Max Weber",
        "Emile Durkheim",
        "Pierre Bourdieu",
        "Maduniyet Çalışmaları"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_33",
      "text": "'Feminizmin İkinci Dalgası' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Michel Foucault",
        "Auguste Comte",
        "Simone de Beauvoir",
        "Pierre Bourdieu"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_34",
      "text": "'Cinsiyet Belası' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Emile Durkheim",
        "Pierre Bourdieu",
        "Karl Marx",
        "Judith Butler"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_35",
      "text": "Sosyolojide 'Ataerki' kavramı neyi ifade eder?",
      "options": [
        "Patriyarka",
        "Ekonomik Enflasyonu",
        "Nüfus Dağılımını",
        "Sınıfsal Çatışmayı"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_36",
      "text": "Sosyolojide 'Toplumsal Cinsiyet' kavramı neyi ifade eder?",
      "options": [
        "Sınıfsal Çatışmayı",
        "Ekonomik Enflasyonu",
        "Gender",
        "Nüfus Dağılımını"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_37",
      "text": "Sosyolojide 'Cam Tavan' kavramı neyi ifade eder?",
      "options": [
        "Ekonomik Enflasyonu",
        "Sınıfsal Çatışmayı",
        "Nüfus Dağılımını",
        "Kadınların İş Hayatındaki Engelleri"
      ],
      "correct": 3
    },
    {
      "id": "sosyoloji_38",
      "text": "Sosyolojide 'Mobbing' kavramı neyi ifade eder?",
      "options": [
        "Ekonomik Enflasyonu",
        "Nüfus Dağılımını",
        "İş Yerinde Psikolojik Taciz",
        "Sınıfsal Çatışmayı"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_39",
      "text": "Sosyolojide 'Asimilasyon' kavramı neyi ifade eder?",
      "options": [
        "Ekonomik Enflasyonu",
        "Bir kültürün diğerini eritmesi",
        "Nüfus Dağılımını",
        "Sınıfsal Çatışmayı"
      ],
      "correct": 1
    }
  ],
  "karisik": [
    {
      "id": "sinema_5",
      "text": "Kült haline gelmiş 'Kış Uykusu' filminin yönetmeni kimdir?",
      "options": [
        "Alfred Hitchcock",
        "Nuri Bilge Ceylan",
        "Roman Polanski",
        "Yavuz Turgul"
      ],
      "correct": 1
    },
    {
      "id": "sosyoloji_23",
      "text": "'Görünmez El' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "İbn Haldun",
        "Adam Smith",
        "Jean Baudrillard",
        "Karl Marx"
      ],
      "correct": 1
    },
    {
      "id": "mitoloji_turk_37",
      "text": "Türk Mitolojisi Soru 28",
      "options": [
        "A",
        "B",
        "D",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_29",
      "text": "Tarihte büyük yankı uyandıran 'Nagasaki'ye Atom Bombası Atılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "9 Ağustos 1945",
        "1526",
        "1945",
        "19 Mayıs 1919"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_iskandinav_34",
      "text": "İskandinav Mitolojisi Soru 25",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_35",
      "text": "Sosyolojide 'Ataerki' kavramı neyi ifade eder?",
      "options": [
        "Patriyarka",
        "Ekonomik Enflasyonu",
        "Nüfus Dağılımını",
        "Sınıfsal Çatışmayı"
      ],
      "correct": 0
    },
    {
      "id": "tarih_9",
      "text": "I. Dünya Savaşı'nın Başlaması ile özdeşleşen tarihi kişilik kimdir?",
      "options": [
        "Avrupa Devletleri",
        "Fatih Sultan Mehmet",
        "Yurtsuz John",
        "Alparslan"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_34",
      "text": "Türk Mitolojisi Soru 25",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_28",
      "text": "Türk Mitolojisi Soru 19",
      "options": [
        "C",
        "B",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_roma_25",
      "text": "Roma Mitolojisi Soru 19",
      "options": [
        "A",
        "C",
        "D",
        "B"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_turk_12",
      "text": "Türk Mitolojisi Soru 3",
      "options": [
        "B",
        "C",
        "A",
        "D"
      ],
      "correct": 2
    },
    {
      "id": "gundem_35",
      "text": "Kısa videolarla tüm dünyada milyarlarca kullanıcıya ulaşan sosyal medya platformu hangisidir?",
      "options": [
        "TikTok",
        "Arjantin",
        "Togg",
        "Alper Gezeravcı"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_1",
      "text": "Roma mitolojisinde Neptün, Yunan mitolojisindeki hangi tanrının karşılığıdır?",
      "options": [
        "Hermes",
        "Dionysos",
        "Poseidon",
        "Apollon"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_15",
      "text": "'Habitus' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Pierre Bourdieu",
        "Edward Said",
        "Karl Marx",
        "İbn Haldun"
      ],
      "correct": 0
    },
    {
      "id": "sosyoloji_31",
      "text": "'Oryantalizm' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Herbert Spencer",
        "İbn Haldun",
        "Edward Said",
        "Jean Baudrillard"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_iskandinav_23",
      "text": "İskandinav Mitolojisi Soru 14",
      "options": [
        "A",
        "D",
        "B",
        "C"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_11",
      "text": "Siyaset biliminde ve tarihinde 'İşçi sınıfının haklarını ve sosyal adaleti savunan ideoloji' nedir/kimdir?",
      "options": [
        "1952",
        "Sosyalizm",
        "Monarşi",
        "1989"
      ],
      "correct": 1
    },
    {
      "id": "cografya_43",
      "text": "İngiltere hangi kıtada yer almaktadır?",
      "options": [
        "Okyanusya",
        "Asya",
        "Avrupa",
        "Afrika"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_turk_8",
      "text": "Türk mitolojisinde Dünyanın Merkezindeki Ağaç olarak bilinen figür kimdir/nedir?",
      "options": [
        "Börü",
        "Kayra Han",
        "Hayat Ağacı",
        "Gök Tengri"
      ],
      "correct": 2
    },
    {
      "id": "spor_27",
      "text": "Spor Genel Kültür 6",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "mitoloji_turk_33",
      "text": "Türk Mitolojisi Soru 24",
      "options": [
        "B",
        "D",
        "C",
        "A"
      ],
      "correct": 3
    },
    {
      "id": "gundem_12",
      "text": "2022 Dünya Kupası'nı kazanan ülke hangisidir?",
      "options": [
        "Kızılelma",
        "Bitcoin",
        "Arjantin",
        "2022"
      ],
      "correct": 2
    },
    {
      "id": "siyaset_13",
      "text": "Siyaset biliminde ve tarihinde 'NATO'nun açılımı' nedir/kimdir?",
      "options": [
        "George Washington",
        "Kuzey Atlantik Antlaşması Örgütü",
        "Demokrasi",
        "Monarşi"
      ],
      "correct": 1
    },
    {
      "id": "siyaset_28",
      "text": "Siyaset biliminde ve tarihinde 'Türkiye'nin çok partili hayata geçiş yılı' nedir/kimdir?",
      "options": [
        "1946",
        "Turgut Özal",
        "1952",
        "Teokrasi"
      ],
      "correct": 0
    },
    {
      "id": "din_3",
      "text": "Dini inanışlara göre 'İslam inancına göre vahiy meleği' hangisidir/kimdir?",
      "options": [
        "Cebrail",
        "Reenkarnasyon",
        "Sinagog / Havra",
        "Vatikan"
      ],
      "correct": 0
    },
    {
      "id": "gundem_38",
      "text": "Türkiye'nin uzay çalışmalarını yürüten kurumun (TUA) açılımı nedir?",
      "options": [
        "Orhan Pamuk",
        "Togg",
        "Türkiye Uzay Ajansı",
        "Elon Musk"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_7",
      "text": "Tarihte büyük yankı uyandıran 'Amasya Genelgesi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1945",
        "22 Haziran 1919",
        "1989",
        "19 Mayıs 1919"
      ],
      "correct": 1
    },
    {
      "id": "edebiyat_25",
      "text": "'Kuyucaklı Yusuf' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Sabahattin Ali",
        "Orhan Pamuk",
        "Ahmet Hamdi Tanpınar",
        "Dostoyevski"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_yunan_8",
      "text": "Yunan mitolojisinde Zeka ve Strateji Tanrıçası kimdir?",
      "options": [
        "Apollon",
        "Hermes",
        "Athena",
        "Hephaistos"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_33",
      "text": "Yunan Mitolojisi Soru 21",
      "options": [
        "A",
        "C",
        "B",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "spor_18",
      "text": "Bir tenis maçında 'Deuce' ne anlama gelir?",
      "options": [
        "Çift Hata",
        "Maç Sayısı",
        "Servis Kırma",
        "40-40 Eşitlik"
      ],
      "correct": 3
    },
    {
      "id": "edebiyat_23",
      "text": "'Devlet Ana' adlı ölümsüz eserin yazarı kimdir?",
      "options": [
        "Kemal Tahir",
        "F. Scott Fitzgerald",
        "Halide Edip Adıvar",
        "Zülfü Livaneli"
      ],
      "correct": 0
    },
    {
      "id": "tarih_30",
      "text": "Preveze Deniz Zaferi hangi yılda gerçekleşmiştir?",
      "options": [
        "1492",
        "1974",
        "1538",
        "1939"
      ],
      "correct": 2
    },
    {
      "id": "sosyoloji_16",
      "text": "'Tüketim Toplumu' üzerine yaptığı sosyolojik çalışmalarıyla bilinen düşünür kimdir?",
      "options": [
        "Auguste Comte",
        "Zygmunt Bauman",
        "Jean Baudrillard",
        "Pierre Bourdieu"
      ],
      "correct": 2
    },
    {
      "id": "mitoloji_yunan_13",
      "text": "Yunan Mitolojisi Soru 1",
      "options": [
        "B",
        "A",
        "C",
        "D"
      ],
      "correct": 1
    },
    {
      "id": "spor_15",
      "text": "Boks maçlarının yapıldığı alana ne ad verilir?",
      "options": [
        "Ring",
        "Minder",
        "Pist",
        "Kort"
      ],
      "correct": 0
    },
    {
      "id": "gundem_19",
      "text": "Nobel Kimya Ödülü alan ilk ve tek Türk bilim insanı kimdir?",
      "options": [
        "Aziz Sancar",
        "Paris",
        "SpaceX",
        "Bitcoin"
      ],
      "correct": 0
    },
    {
      "id": "mitoloji_roma_14",
      "text": "Roma Mitolojisi Soru 8",
      "options": [
        "A",
        "B",
        "C",
        "D"
      ],
      "correct": 0
    },
    {
      "id": "siyaset_27",
      "text": "Siyaset biliminde ve tarihinde 'TBMM hangi tarihte açılmıştır' nedir/kimdir?",
      "options": [
        "23 Nisan 1920",
        "Oligarşi",
        "1989",
        "Brüksel"
      ],
      "correct": 0
    },
    {
      "id": "psikoloji_15",
      "text": "'Gestalt Psikolojisi' kavramı/kuramı ile tanınan ünlü psikolog kimdir?",
      "options": [
        "Max Wertheimer",
        "Sigmund Freud",
        "Erik Erikson",
        "Jean Piaget"
      ],
      "correct": 0
    }
  ],
  "tarihte_bugun": [
    {
      "id": "tarihte_bugun_0",
      "text": "Tarihte büyük yankı uyandıran 'TBMM'nin açılışı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1492",
        "23 Nisan 1920",
        "1526",
        "19 Mayıs 1919"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_1",
      "text": "Tarihte büyük yankı uyandıran 'Cumhuriyet'in İlanı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1969",
        "1974",
        "29 Ekim 1923",
        "1991"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_2",
      "text": "Tarihte büyük yankı uyandıran 'Atatürk'ün Vefatı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1974",
        "10 Kasım 1938",
        "1492",
        "29 Ekim 1923"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_3",
      "text": "Tarihte büyük yankı uyandıran 'Lozan Barış Antlaşması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1939",
        "1945",
        "1526",
        "24 Temmuz 1923"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_4",
      "text": "Tarihte büyük yankı uyandıran 'Mondros Ateşkes Antlaşması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "30 Ekim 1918",
        "19 Mayıs 1919",
        "1071",
        "1453"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_5",
      "text": "Tarihte büyük yankı uyandıran 'Erzurum Kongresi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1974",
        "23 Temmuz 1919",
        "30 Ağustos 1922",
        "1989"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_6",
      "text": "Tarihte büyük yankı uyandıran 'Sivas Kongresi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "4 Eylül 1919",
        "23 Nisan 1920",
        "19 Mayıs 1919",
        "1789"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_7",
      "text": "Tarihte büyük yankı uyandıran 'Amasya Genelgesi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1945",
        "22 Haziran 1919",
        "1989",
        "19 Mayıs 1919"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_8",
      "text": "Tarihte büyük yankı uyandıran 'Atatürk'ün Samsun'a Çıkışı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1914",
        "19 Mayıs 1919",
        "1974",
        "23 Nisan 1920"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_9",
      "text": "Tarihte büyük yankı uyandıran 'Sakarya Meydan Muharebesi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1945",
        "1071",
        "1974",
        "1921"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_10",
      "text": "Tarihte büyük yankı uyandıran 'Büyük Taarruz ve Başkomutanlık Meydan Muharebesi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1945",
        "26-30 Ağustos 1922",
        "30 Ağustos 1922",
        "1453"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_11",
      "text": "Tarihte büyük yankı uyandıran 'İzmir'in Kurtuluşu' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "9 Eylül 1922",
        "1939",
        "1453",
        "1492"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_12",
      "text": "Tarihte büyük yankı uyandıran 'Saltanatın Kaldırılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1 Kasım 1922",
        "1492",
        "1945",
        "1526"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_13",
      "text": "Tarihte büyük yankı uyandıran 'Halifeliğin Kaldırılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1969",
        "1914",
        "1453",
        "3 Mart 1924"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_14",
      "text": "Tarihte büyük yankı uyandıran 'Harf İnkılabı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "30 Ağustos 1922",
        "1 Kasım 1928",
        "1939",
        "1526"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_15",
      "text": "Tarihte büyük yankı uyandıran 'Kadınlara Seçme ve Seçilme Hakkı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "5 Aralık 1934",
        "19 Mayıs 1919",
        "1453",
        "1939"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_16",
      "text": "Tarihte büyük yankı uyandıran 'Soyadı Kanunu' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "19 Mayıs 1919",
        "1453",
        "23 Nisan 1920",
        "21 Haziran 1934"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_17",
      "text": "Tarihte büyük yankı uyandıran 'Kıbrıs Barış Harekatı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1914",
        "1789",
        "20 Temmuz 1974",
        "1969"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_18",
      "text": "Tarihte büyük yankı uyandıran 'İstanbul'un Fethi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "23 Nisan 1920",
        "29 Mayıs 1453",
        "1492",
        "1914"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_19",
      "text": "Tarihte büyük yankı uyandıran 'Malazgirt Zaferi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "26 Ağustos 1071",
        "1945",
        "1071",
        "1939"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_20",
      "text": "Tarihte büyük yankı uyandıran 'Mohaç Meydan Muharebesi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1989",
        "29 Ağustos 1526",
        "1071",
        "1789"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_21",
      "text": "Tarihte büyük yankı uyandıran 'Preveze Deniz Zaferi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1492",
        "29 Ekim 1923",
        "27 Eylül 1538",
        "19 Mayıs 1919"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_22",
      "text": "Tarihte büyük yankı uyandıran 'Çanakkale Deniz Zaferi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1453",
        "18 Mart 1915",
        "29 Ekim 1923",
        "1939"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_23",
      "text": "Tarihte büyük yankı uyandıran 'Kut'ül Amare Zaferi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "19 Mayıs 1919",
        "1974",
        "1071",
        "29 Nisan 1916"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_24",
      "text": "Tarihte büyük yankı uyandıran 'Amerika'nın Keşfi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "30 Ağustos 1922",
        "19 Mayıs 1919",
        "1789",
        "12 Ekim 1492"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_25",
      "text": "Tarihte büyük yankı uyandıran 'Fransız İhtilali' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "23 Nisan 1920",
        "14 Temmuz 1789",
        "1789",
        "29 Ekim 1923"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_26",
      "text": "Tarihte büyük yankı uyandıran '1. Dünya Savaşı'nın Başlaması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "28 Temmuz 1914",
        "1914",
        "1939",
        "30 Ağustos 1922"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_27",
      "text": "Tarihte büyük yankı uyandıran '2. Dünya Savaşı'nın Başlaması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "30 Ağustos 1922",
        "29 Ekim 1923",
        "1492",
        "1 Eylül 1939"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_28",
      "text": "Tarihte büyük yankı uyandıran 'Hiroşima'ya Atom Bombası Atılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "6 Ağustos 1945",
        "1939",
        "1914",
        "1969"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_29",
      "text": "Tarihte büyük yankı uyandıran 'Nagasaki'ye Atom Bombası Atılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "9 Ağustos 1945",
        "1526",
        "1945",
        "19 Mayıs 1919"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_30",
      "text": "Tarihte büyük yankı uyandıran 'Sovyetler Birliği'nin Dağılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "26 Aralık 1991",
        "1789",
        "1071",
        "1945"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_31",
      "text": "Tarihte büyük yankı uyandıran 'Berlin Duvarı'nın Yıkılması' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1969",
        "1974",
        "1492",
        "9 Kasım 1989"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_32",
      "text": "Tarihte büyük yankı uyandıran 'İnsanın Aya İlk Ayak Basışı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1974",
        "1071",
        "20 Temmuz 1969",
        "29 Ekim 1923"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_33",
      "text": "Tarihte büyük yankı uyandıran 'İlk Bilgisayar ENIAC'ın İcadı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1789",
        "1946",
        "1939",
        "29 Ekim 1923"
      ],
      "correct": 1
    },
    {
      "id": "tarihte_bugun_34",
      "text": "Tarihte büyük yankı uyandıran 'Dünya Sağlık Örgütü (WHO) Kuruluşu' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1526",
        "29 Ekim 1923",
        "7 Nisan 1948",
        "1989"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_35",
      "text": "Tarihte büyük yankı uyandıran 'NATO'nun Kuruluşu' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "4 Nisan 1949",
        "30 Ağustos 1922",
        "1989",
        "1789"
      ],
      "correct": 0
    },
    {
      "id": "tarihte_bugun_36",
      "text": "Tarihte büyük yankı uyandıran 'Çernobil Nükleer Felaketi' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1989",
        "1945",
        "1526",
        "26 Nisan 1986"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_37",
      "text": "Tarihte büyük yankı uyandıran 'Titanic'in Batışı' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1939",
        "1945",
        "15 Nisan 1912",
        "19 Mayıs 1919"
      ],
      "correct": 2
    },
    {
      "id": "tarihte_bugun_38",
      "text": "Tarihte büyük yankı uyandıran 'Wright Kardeşlerin İlk Uçuşu' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1945",
        "1526",
        "1492",
        "17 Aralık 1903"
      ],
      "correct": 3
    },
    {
      "id": "tarihte_bugun_39",
      "text": "Tarihte büyük yankı uyandıran 'Matbaanın İcadı (Gutenberg)' hangi tarihte/yılda gerçekleşmiştir?",
      "options": [
        "1071",
        "23 Nisan 1920",
        "1969",
        "1440"
      ],
      "correct": 3
    }
  ]
,
  "milli_mucadele": [
    {
        "id": "ataturk_milli_mucadele_0",
        "text": "Mustafa Kemal'in Samsun'a çıktığı tarih hangisidir?",
        "options": [
            "19 Mayıs 1919",
            "23 Nisan 1920",
            "29 Ekim 1923",
            "30 Ağustos 1922"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_1",
        "text": "Kurtuluş Savaşı'nın askeri safhasını bitiren antlaşma hangisidir?",
        "options": [
            "Sevr Antlaşması",
            "Mudanya Mütarekesi",
            "Lozan Antlaşması",
            "Ankara Antlaşması"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_2",
        "text": "Mustafa Kemal'in 'Ordular, ilk hedefiniz Akdeniz'dir. İleri!' emrini verdiği savaş hangisidir?",
        "options": [
            "Sakarya Meydan Muharebesi",
            "I. İnönü Muharebesi",
            "Büyük Taarruz",
            "Eskişehir-Kütahya Muharebeleri"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_3",
        "text": "Sivas Kongresi'nde tüm milli cemiyetler hangi isim altında birleştirilmiştir?",
        "options": [
            "Kuvayi Milliye",
            "Anadolu ve Rumeli Müdafaa-i Hukuk Cemiyeti",
            "Karakol Cemiyeti",
            "Heyet-i Temsiliye"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_4",
        "text": "TBMM'nin açılış tarihi nedir?",
        "options": [
            "23 Nisan 1920",
            "19 Mayıs 1919",
            "29 Ekim 1923",
            "1 Kasım 1922"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_5",
        "text": "Amasya Genelgesi'nde 'Milletin bağımsızlığını yine milletin azim ve kararı kurtaracaktır.' maddesi neyin işaretidir?",
        "options": [
            "Saltanatın devam edeceğinin",
            "Milli egemenliğe dayalı yeni bir devletin",
            "Manda ve himayenin kabul edileceğinin",
            "Osmanlı hükümetine bağlı kalınacağının"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_6",
        "text": "Erzurum Kongresi'nin toplanma amacı öncelikle hangi bölgenin savunulması içindir?",
        "options": [
            "Batı Anadolu",
            "Doğu Anadolu",
            "Trakya",
            "Güney Anadolu"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_7",
        "text": "Batı Cephesi komutanlığına kim atanmıştır?",
        "options": [
            "Fevzi Çakmak",
            "Kazım Karabekir",
            "İsmet İnönü",
            "Refet Bele"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_8",
        "text": "Doğu Cephesi'nde Ermenilere karşı elde edilen başarıdan sonra hangi antlaşma imzalanmıştır?",
        "options": [
            "Gümrü Antlaşması",
            "Batum Antlaşması",
            "Kars Antlaşması",
            "Moskova Antlaşması"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_9",
        "text": "Düzenli ordunun kazandığı ilk askeri zafer hangisidir?",
        "options": [
            "Büyük Taarruz",
            "Sakarya Meydan Muharebesi",
            "II. İnönü Muharebesi",
            "I. İnönü Muharebesi"
        ],
        "correct": 3
    },
    {
        "id": "ataturk_milli_mucadele_10",
        "text": "Mustafa Kemal'e 'Gazi' unvanı ve 'Mareşal' rütbesi hangi savaştan sonra verilmiştir?",
        "options": [
            "Büyük Taarruz",
            "Çanakkale Savaşı",
            "Sakarya Meydan Muharebesi",
            "I. İnönü Muharebesi"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_11",
        "text": "Misak-ı Milli nerede kabul edilmiştir?",
        "options": [
            "TBMM'de",
            "Son Osmanlı Mebusan Meclisi'nde",
            "Sivas Kongresi'nde",
            "Erzurum Kongresi'nde"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_12",
        "text": "Güney Cephesi'nde Fransızlara karşı savunma yapan kahramanlarımızdan Sütçü İmam hangi ilimizdedir?",
        "options": [
            "Antep",
            "Urfa",
            "Maraş",
            "Adana"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_13",
        "text": "İstiklal Marşı hangi savaştan sonra kabul edilmiştir?",
        "options": [
            "I. İnönü Muharebesi",
            "II. İnönü Muharebesi",
            "Sakarya Meydan Muharebesi",
            "Büyük Taarruz"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_14",
        "text": "Kurtuluş Savaşı'nı fiilen sona erdiren diplomatik belge hangisidir?",
        "options": [
            "Lozan Barış Antlaşması",
            "Mudanya Ateşkes Antlaşması",
            "Ankara Antlaşması",
            "Gümrü Antlaşması"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_15",
        "text": "Hangi antlaşma ile Sevr Antlaşması tamamen geçersiz kılınmıştır?",
        "options": [
            "Lozan Barış Antlaşması",
            "Mudanya Ateşkes Antlaşması",
            "Moskova Antlaşması",
            "Kars Antlaşması"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_16",
        "text": "Tekalif-i Milliye emirleri hangi savaştan önce ordunun ihtiyaçlarını karşılamak için çıkarılmıştır?",
        "options": [
            "I. İnönü Muharebesi",
            "Eskişehir-Kütahya Muharebeleri",
            "Sakarya Meydan Muharebesi",
            "Büyük Taarruz"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_17",
        "text": "Mustafa Kemal Paşa'nın başkomutanlık yetkisini ilk kez kullandığı savaş hangisidir?",
        "options": [
            "I. İnönü Muharebesi",
            "Sakarya Meydan Muharebesi",
            "Büyük Taarruz",
            "Çanakkale Savaşı"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_18",
        "text": "Amasya Görüşmeleri kimler arasında yapılmıştır?",
        "options": [
            "Heyet-i Temsiliye ile İstanbul Hükümeti",
            "TBMM ile İtilaf Devletleri",
            "TBMM ile Sovyet Rusya",
            "Heyet-i Temsiliye ile Fransızlar"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_19",
        "text": "Kuvayi Milliye birlikleri ilk kez nerede düşmana karşı silahlı direniş göstermiştir?",
        "options": [
            "İzmir",
            "Hatay Dörtyol",
            "Aydın",
            "Maraş"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_20",
        "text": "Eskişehir-Kütahya savaşlarından sonra TBMM'nin taşınması tartışılan şehir hangisidir?",
        "options": [
            "Sivas",
            "Kayseri",
            "Konya",
            "Erzurum"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_21",
        "text": "Lozan Barış Konferansı'na TBMM adına baş temsilci olarak kim katılmıştır?",
        "options": [
            "Mustafa Kemal Paşa",
            "Rauf Orbay",
            "İsmet Paşa",
            "Fevzi Paşa"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_22",
        "text": "Hatay, Anavatana hangi yıl katılmıştır?",
        "options": [
            "1938",
            "1939",
            "1940",
            "1937"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_23",
        "text": "Sevr Antlaşması'nı imzalayan Osmanlı heyeti TBMM tarafından nasıl değerlendirilmiştir?",
        "options": [
            "Vatan haini",
            "Kahraman",
            "Zorunlu imzacı",
            "Geçersiz heyet"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_24",
        "text": "Sovyet Rusya ile TBMM arasında imzalanan ve doğu sınırımızı büyük ölçüde belirleyen antlaşma hangisidir?",
        "options": [
            "Ankara Antlaşması",
            "Moskova Antlaşması",
            "Kars Antlaşması",
            "Gümrü Antlaşması"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_25",
        "text": "Sakarya Savaşı'nın diğer adı olarak bilinen isim hangisidir?",
        "options": [
            "Subaylar Savaşı",
            "Aydınlar Savaşı",
            "Büyük Yıkım",
            "Son Savunma"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_milli_mucadele_26",
        "text": "Mustafa Kemal'in 'Siz orada yalnız düşmanı değil, milletin makus talihini de yendiniz.' sözünü kime söylemiştir?",
        "options": [
            "Kazım Karabekir",
            "Fevzi Çakmak",
            "İsmet İnönü",
            "Rauf Orbay"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_milli_mucadele_27",
        "text": "Hangi şehrimiz düşman işgalinden kurtuluş günü olarak 9 Eylül'ü kutlar?",
        "options": [
            "Bursa",
            "İzmir",
            "Aydın",
            "Manisa"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_28",
        "text": "Kurtuluş Savaşı'nda denizlerdeki mücadeleyi büyük ölçüde üstlenen kahraman gemimiz hangisidir?",
        "options": [
            "Bandırma",
            "Alemdar",
            "Nusret",
            "Yavuz"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_milli_mucadele_29",
        "text": "Büyük Taarruz'un başlama tarihi nedir?",
        "options": [
            "26 Ağustos 1922",
            "30 Ağustos 1922",
            "9 Eylül 1922",
            "1 Eylül 1922"
        ],
        "correct": 0
    }
],
  "cagdas_turkiye": [
    {
        "id": "ataturk_cagdas_turkiye_30",
        "text": "Cumhuriyet hangi tarihte ilan edilmiştir?",
        "options": [
            "29 Ekim 1923",
            "23 Nisan 1920",
            "1 Kasım 1922",
            "3 Mart 1924"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_31",
        "text": "Saltanatın kaldırılması hangi tarihte gerçekleşmiştir?",
        "options": [
            "29 Ekim 1923",
            "1 Kasım 1922",
            "3 Mart 1924",
            "19 Mayıs 1919"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_32",
        "text": "Halifelik hangi tarihte kaldırılmıştır?",
        "options": [
            "1 Kasım 1922",
            "29 Ekim 1923",
            "3 Mart 1924",
            "1 Kasım 1928"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_33",
        "text": "Tevhid-i Tedrisat Kanunu ile ne amaçlanmıştır?",
        "options": [
            "Kılık kıyafetin modernleşmesi",
            "Eğitim ve öğretimin birleştirilmesi",
            "Yeni harflerin kabulü",
            "Hukuk sisteminin laikleşmesi"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_34",
        "text": "Harf İnkılabı (Yeni Türk Harflerinin Kabulü) hangi yıl yapılmıştır?",
        "options": [
            "1926",
            "1928",
            "1932",
            "1934"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_35",
        "text": "Soyadı Kanunu hangi yıl kabul edilmiştir?",
        "options": [
            "1934",
            "1928",
            "1926",
            "1931"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_36",
        "text": "Türk kadınlarına seçme ve seçilme hakkı tanıyan anayasa değişikliği hangi yıl tam olarak (milletvekili seçilme) gerçekleşmiştir?",
        "options": [
            "1930",
            "1933",
            "1934",
            "1935"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_37",
        "text": "Türk Medeni Kanunu hangi ülkeden örnek alınarak hazırlanmıştır?",
        "options": [
            "Fransa",
            "Almanya",
            "İtalya",
            "İsviçre"
        ],
        "correct": 3
    },
    {
        "id": "ataturk_cagdas_turkiye_38",
        "text": "Medeni Kanun'un kabulü ile aşağıdakilerden hangisi gerçekleşmemiştir?",
        "options": [
            "Resmi nikah zorunluluğu",
            "Kadınlara siyasi hakların verilmesi",
            "Tek eşliliğin kabulü",
            "Miras hukukunda eşitlik"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_39",
        "text": "Tekke, zaviye ve türbelerin kapatılması hangi ilke ile doğrudan ilişkilidir?",
        "options": [
            "Devletçilik",
            "Laiklik",
            "Milliyetçilik",
            "Halkçılık"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_40",
        "text": "Atatürk İlkeleri anayasaya hangi yıl girmiştir?",
        "options": [
            "1924",
            "1928",
            "1937",
            "1934"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_41",
        "text": "Devletin ekonomik hayata aktif olarak müdahale etmesini savunan Atatürk ilkesi hangisidir?",
        "options": [
            "Cumhuriyetçilik",
            "Halkçılık",
            "Devletçilik",
            "İnkılapçılık"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_42",
        "text": "Türk Tarih Kurumu ve Türk Dil Kurumu'nun kurulması hangi Atatürk ilkesi ile doğrudan ilgilidir?",
        "options": [
            "Milliyetçilik",
            "Laiklik",
            "Devletçilik",
            "Cumhuriyetçilik"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_43",
        "text": "Kılık Kıyafet İnkılabı çerçevesinde Şapka Kanunu hangi yıl çıkarılmıştır?",
        "options": [
            "1925",
            "1928",
            "1934",
            "1923"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_44",
        "text": "Atatürk döneminde çok partili hayata geçiş denemelerinden ilki hangi parti ile yapılmıştır?",
        "options": [
            "Serbest Cumhuriyet Fırkası",
            "Terakkiperver Cumhuriyet Fırkası",
            "Demokrat Parti",
            "Milli Kalkınma Partisi"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_45",
        "text": "Terakkiperver Cumhuriyet Fırkası'nın kapatılmasına neden olan olay hangisidir?",
        "options": [
            "Menemen Olayı",
            "Şeyh Sait İsyanı",
            "İzmir Suikastı",
            "Balkan Antantı"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_46",
        "text": "Takvim, saat ve ölçülerde yapılan değişikliklerin temel amacı nedir?",
        "options": [
            "Avrupa ile ticari ve sosyal ilişkileri kolaylaştırmak",
            "Gelenekleri canlandırmak",
            "Dini kurumları güçlendirmek",
            "Tarımı geliştirmek"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_47",
        "text": "Aşar vergisinin kaldırılması hangi Atatürk ilkesi doğrultusunda çiftçiyi rahatlatmak için yapılmıştır?",
        "options": [
            "Halkçılık",
            "Laiklik",
            "Cumhuriyetçilik",
            "Milliyetçilik"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_48",
        "text": "1923 yılında toplanan ve yeni Türkiye'nin ekonomi politikalarının belirlendiği kongre hangisidir?",
        "options": [
            "İzmir İktisat Kongresi",
            "Sivas Kongresi",
            "Erzurum Kongresi",
            "Milli İktisat Kongresi"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_49",
        "text": "Türkiye Cumhuriyeti'nin ilk Diyanet İşleri Başkanı kimdir?",
        "options": [
            "Rıfat Börekçi",
            "Mehmet Akif Ersoy",
            "Fevzi Çakmak",
            "Elmalılı Hamdi Yazır"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_50",
        "text": "Kabotaj Kanunu'nun kabulü ile ne sağlanmıştır?",
        "options": [
            "Türk denizlerinde gemi işletme hakkının Türklere verilmesi",
            "Boğazların kontrolünün Türkiye'ye geçmesi",
            "Deniz kuvvetlerinin kurulması",
            "Limanların yabancılara açılması"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_51",
        "text": "Türkiye'nin Milletler Cemiyeti'ne üye olduğu yıl hangisidir?",
        "options": [
            "1930",
            "1932",
            "1934",
            "1936"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_52",
        "text": "Montrö Boğazlar Sözleşmesi hangi yıl imzalanmıştır?",
        "options": [
            "1923",
            "1932",
            "1936",
            "1939"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_53",
        "text": "Atatürk'ün Nutuk adlı eseri hangi yılları kapsamaktadır?",
        "options": [
            "1919 - 1927",
            "1920 - 1923",
            "1919 - 1938",
            "1923 - 1938"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_cagdas_turkiye_54",
        "text": "Mustafa Kemal Atatürk'ün 'En büyük eserim' dediği kurum/kavram hangisidir?",
        "options": [
            "Türk Tarih Kurumu",
            "Türkiye Cumhuriyeti",
            "TBMM",
            "Cumhuriyet Halk Partisi"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_55",
        "text": "Atatürk döneminde açılan ilk yükseköğretim kurumu olan Darülfünun, 1933 reformuyla hangi üniversiteye dönüşmüştür?",
        "options": [
            "Ankara Üniversitesi",
            "İstanbul Üniversitesi",
            "Gazi Üniversitesi",
            "Boğaziçi Üniversitesi"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_56",
        "text": "Millet Mektepleri'nin açılma amacı nedir?",
        "options": [
            "Üniversite öğrencilerine burs vermek",
            "Yetişkinlere yeni Türk harflerini öğretmek",
            "Köy öğretmenleri yetiştirmek",
            "Subay yetiştirmek"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_cagdas_turkiye_57",
        "text": "Hafta tatilinin Cuma gününden Pazar gününe alınması hangi yıl gerçekleşmiştir?",
        "options": [
            "1925",
            "1928",
            "1935",
            "1930"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_58",
        "text": "Soyadı Kanunu ile Mustafa Kemal'e 'Atatürk' soyadını kim vermiştir?",
        "options": [
            "Halk",
            "İsmet İnönü",
            "Türkiye Büyük Millet Meclisi (TBMM)",
            "Türk Dil Kurumu"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_cagdas_turkiye_59",
        "text": "Aşağıdakilerden hangisi Atatürk'ün laiklik ilkesi doğrultusunda yapılan bir inkılaptır?",
        "options": [
            "Soyadı Kanunu",
            "Aşar vergisinin kaldırılması",
            "Halifeliğin kaldırılması",
            "Kabotaj Kanunu"
        ],
        "correct": 2
    }
],
  "kim_taniyor": [
    {
        "id": "ataturk_kim_taniyor_60",
        "text": "Mustafa Kemal Atatürk hangi yılda doğmuştur?",
        "options": [
            "1880",
            "1881",
            "1882",
            "1883"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_61",
        "text": "Atatürk'ün annesinin adı nedir?",
        "options": [
            "Makbule Hanım",
            "Zübeyde Hanım",
            "Aliye Hanım",
            "Fikriye Hanım"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_62",
        "text": "Atatürk'ün babasının adı nedir?",
        "options": [
            "Ali Rıza Efendi",
            "Mehmet Efendi",
            "Ahmet Rıza Bey",
            "Mustafa Bey"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_63",
        "text": "Mustafa'ya 'Kemal' adını veren öğretmeni hangi dersin öğretmenidir?",
        "options": [
            "Tarih",
            "Edebiyat",
            "Matematik",
            "Fransızca"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_64",
        "text": "Atatürk'ün kız kardeşinin adı nedir?",
        "options": [
            "Sabiha",
            "Ülkü",
            "Afet",
            "Makbule"
        ],
        "correct": 3
    },
    {
        "id": "ataturk_kim_taniyor_65",
        "text": "Atatürk'ün doğduğu şehir neresidir?",
        "options": [
            "İstanbul",
            "Selanik",
            "Manastır",
            "Sofya"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_66",
        "text": "Mustafa Kemal'in askeri ataşe olarak görev yaptığı şehir hangisidir?",
        "options": [
            "Paris",
            "Londra",
            "Sofya",
            "Berlin"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_67",
        "text": "Atatürk'ün çok sevdiği atının adı nedir?",
        "options": [
            "Sakarya",
            "Anadolu",
            "Poyraz",
            "Gülbahar"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_68",
        "text": "Atatürk'ün köpeğinin adı nedir?",
        "options": [
            "Karabaş",
            "Foks",
            "Tarçın",
            "Cesur"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_69",
        "text": "Mustafa Kemal Atatürk'ün manevi kızlarından biri olan, ilk kadın savaş pilotumuz kimdir?",
        "options": [
            "Afet İnan",
            "Sabiha Gökçen",
            "Ülkü Adatepe",
            "Zehra Aylin"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_70",
        "text": "Atatürk'ün okuduğu ilk okul hangisidir?",
        "options": [
            "Şemsi Efendi İlkokulu",
            "Mahalle Mektebi",
            "Selanik Askeri Rüştiyesi",
            "Manastır Askeri İdadisi"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_71",
        "text": "Mustafa Kemal'in 'Kemal' ismini aldığı okul hangisidir?",
        "options": [
            "Mahalle Mektebi",
            "Şemsi Efendi İlkokulu",
            "Selanik Askeri Rüştiyesi",
            "Manastır Askeri İdadisi"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_72",
        "text": "Atatürk hangi askeri okuldan Kurmay Yüzbaşı rütbesiyle mezun olmuştur?",
        "options": [
            "Harp Okulu",
            "Harp Akademisi",
            "Askeri İdadi",
            "Askeri Rüştiye"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_73",
        "text": "Atatürk'ün katıldığı ilk savaş hangisidir?",
        "options": [
            "Trablusgarp Savaşı",
            "Balkan Savaşları",
            "Çanakkale Savaşı",
            "I. Dünya Savaşı"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_74",
        "text": "Atatürk'ün Çanakkale Savaşı'nda rütbesi neydi?",
        "options": [
            "Kurmay Yüzbaşı",
            "Binbaşı",
            "Yarbay / Albay",
            "Tümgeneral"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_75",
        "text": "Mustafa Kemal'in 'Anafartalar Kahramanı' olarak tanındığı savaş hangisidir?",
        "options": [
            "Sakarya Savaşı",
            "Çanakkale Savaşı",
            "Trablusgarp Savaşı",
            "Büyük Taarruz"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_76",
        "text": "Atatürk'ün vefat ettiği tarih nedir?",
        "options": [
            "10 Kasım 1938",
            "29 Ekim 1938",
            "10 Kasım 1937",
            "23 Nisan 1939"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_77",
        "text": "Atatürk'ün vefat ettiği yer neresidir?",
        "options": [
            "Dolmabahçe Sarayı",
            "Çankaya Köşkü",
            "Topkapı Sarayı",
            "Yıldız Sarayı"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_78",
        "text": "Atatürk'ün anıt mezarı Anıtkabir'in bulunduğu tepeye eskiden ne ad verilirdi?",
        "options": [
            "Çankaya Tepesi",
            "Rasattepe",
            "Gazi Tepesi",
            "Kocatepe"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_79",
        "text": "Atatürk'ün naşı Anıtkabir'e taşınmadan önce nerede muhafaza edilmiştir?",
        "options": [
            "Dolmabahçe Sarayı",
            "Etnografya Müzesi",
            "TBMM Bahçesi",
            "Gülhane Parkı"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_80",
        "text": "Atatürk'ün boyu yaklaşık olarak kaç santimetreydi?",
        "options": [
            "1.68",
            "1.74",
            "1.80",
            "1.85"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_81",
        "text": "Atatürk'ün yazdığı geometri kitabının adı nedir?",
        "options": [
            "Geometri",
            "Hendese",
            "Matematik Terimleri",
            "Sayılar Kuramı"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_82",
        "text": "Atatürk'ün en sevdiği yemeklerden biri aşağıdakilerden hangisidir?",
        "options": [
            "Kuru fasulye ve pilav",
            "İskender kebap",
            "Mantı",
            "Karnıyarık"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_83",
        "text": "Atatürk'ün sevdiği müzik türü genellikle nasıldı?",
        "options": [
            "Klasik Müzik",
            "Caz",
            "Türk Sanat Müziği ve Rumeli Türküleri",
            "Opera"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_84",
        "text": "Mustafa Kemal Atatürk'ün nüfusa kayıtlı olduğu il hangisidir?",
        "options": [
            "Selanik",
            "İstanbul",
            "Ankara",
            "Gaziantep"
        ],
        "correct": 3
    },
    {
        "id": "ataturk_kim_taniyor_85",
        "text": "Atatürk'ün okumayı en çok sevdiği kitap türü neydi?",
        "options": [
            "Şiir",
            "Tarih",
            "Roman",
            "Bilim Kurgu"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_86",
        "text": "Atatürk'ün en iyi bildiği yabancı dil hangisiydi?",
        "options": [
            "İngilizce",
            "Almanca",
            "Fransızca",
            "Rusça"
        ],
        "correct": 2
    },
    {
        "id": "ataturk_kim_taniyor_87",
        "text": "Atatürk'ün 'Nutuk' adlı eserini ilk kez nerede okumuştur?",
        "options": [
            "TBMM'de",
            "Cumhuriyet Halk Partisi Kurultayı'nda",
            "Ankara Üniversitesi'nde",
            "Sivas Kongresi'nde"
        ],
        "correct": 1
    },
    {
        "id": "ataturk_kim_taniyor_88",
        "text": "Atatürk, 'Hayatta en hakiki mürşit ilimdir' sözünü hangi şehirde söylemiştir?",
        "options": [
            "İstanbul",
            "Ankara",
            "Samsun",
            "Bursa"
        ],
        "correct": 0
    },
    {
        "id": "ataturk_kim_taniyor_89",
        "text": "Atatürk'ün çocukken dayısının çiftliğinde yapmayı sevdiği iş neydi?",
        "options": [
            "At binmek",
            "Kitap okumak",
            "Karga kovalamak (Tarla bekçiliği)",
            "Balık tutmak"
        ],
        "correct": 2
    }
]
};
